/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Products API
 * API for managing products
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Get paginated list of products with search and filtering
 */
export const getItemsQueryUserMax = 200;

export const getItemsQueryUserRegExp = new RegExp("^[0-9]+(,[0-9]+)\*$");
export const getItemsQueryUserIdMax = 200;

export const getItemsQueryUserIdRegExp = new RegExp("^[0-9]+(,[0-9]+)\*$");
export const getItemsQuerySearchMax = 100;

export const getItemsQueryQMax = 100;

export const getItemsQueryCategoryMax = 50;

export const getItemsQueryMinPriceMin = 0;

export const getItemsQueryMaxPriceMin = 0;

export const getItemsQueryPageDefault = 1;

export const getItemsQueryPerPageDefault = 40;
export const getItemsQueryPerPageMax = 100;

export const getItemsQuerySortDefault = `latest_review_at`;
export const getItemsQueryOrderDefault = `desc`;
export const getItemsQueryContentSearchMax = 200;

export const getItemsQueryContentSearchFieldsMax = 100;

export const getItemsQueryRatingOneMax = 5;

export const getItemsQueryRatingTwoRegExp = new RegExp("^[1-5](,[1-5])\*$");
export const getItemsQueryUpdatedByMax = 200;

export const getItemsQueryUpdatedByRegExp = new RegExp("^[0-9]+(,[0-9]+)\*$");

export const GetItemsQueryParams = zod
    .object({
        user: zod
            .string()
            .max(getItemsQueryUserMax)
            .regex(getItemsQueryUserRegExp)
            .optional()
            .describe("Filter products to those reviewed by the specified user ID(s), comma-separated"),
        user_id: zod
            .string()
            .max(getItemsQueryUserIdMax)
            .regex(getItemsQueryUserIdRegExp)
            .optional()
            .describe(
                "Alias of `user` (filter products to those reviewed by the specified user ID(s), comma-separated)",
            ),
        search: zod
            .string()
            .max(getItemsQuerySearchMax)
            .optional()
            .describe("Search keyword for product name or description"),
        q: zod.string().max(getItemsQueryQMax).optional().describe("Alias of `search`"),
        category_id: zod.number().nullish().describe("Filter by category ID (supports multiple values)"),
        category_ids: zod
            .union([zod.number(), zod.array(zod.number())])
            .optional()
            .describe("Alias of `category_id` (supports multiple values)"),
        parent_category_id: zod
            .number()
            .nullish()
            .describe("Filter by parent category ID (expands to child category_id list)"),
        parent_category_ids: zod
            .union([zod.number(), zod.array(zod.number())])
            .optional()
            .describe("Alias of `parent_category_id` (supports multiple values)"),
        brand_id: zod.number().nullish().describe("Filter by brand ID (supports multiple values)"),
        brand_ids: zod
            .union([zod.number(), zod.array(zod.number())])
            .optional()
            .describe("Alias of `brand_id` (supports multiple values)"),
        product_id: zod.number().optional().describe("Filter by product ID (supports multiple values)"),
        product_ids: zod
            .union([zod.number(), zod.array(zod.number())])
            .optional()
            .describe("Alias of `product_id` (supports multiple values)"),
        category: zod.string().max(getItemsQueryCategoryMax).optional().describe("Filter by product category"),
        min_price: zod.number().min(getItemsQueryMinPriceMin).optional().describe("Minimum price filter"),
        max_price: zod.number().min(getItemsQueryMaxPriceMin).optional().describe("Maximum price filter"),
        price_range: zod
            .string()
            .optional()
            .describe(
                'Price range bucket(s). Accepts comma-separated values (e.g. 1-500 or 1-500,501-1000). \"10001-\" is unbounded upper. The token \"unset\" (admin search only) matches products with no price (null or 0).',
            ),
        page: zod.number().min(1).default(getItemsQueryPageDefault).describe("Page number for pagination"),
        per_page: zod
            .number()
            .min(1)
            .max(getItemsQueryPerPageMax)
            .default(getItemsQueryPerPageDefault)
            .describe("Number of items per page"),
        sort: zod
            .enum(["name", "price", "created_at", "updated_at", "likes_count", "latest_review_at"])
            .default(getItemsQuerySortDefault)
            .describe("Sort field"),
        order: zod.enum(["asc", "desc"]).default(getItemsQueryOrderDefault).describe("Sort order"),
        new_only: zod
            .union([zod.literal(0), zod.literal(1)])
            .optional()
            .describe('If true, filter to products considered \"new\" (recently updated\/created)'),
        recommend_only: zod
            .union([zod.literal(0), zod.literal(1)])
            .optional()
            .describe("If true, filter to recommended products only (based on recommend rank)"),
        ranking_only: zod
            .union([zod.literal(0), zod.literal(1)])
            .optional()
            .describe("If true, ranking mode (typically sort by likes_count desc)"),
        reviewed_only: zod
            .union([zod.literal(0), zod.literal(1)])
            .optional()
            .describe("If 1, filter to products that have at least one review post linked"),
        scored_only: zod
            .union([zod.literal(0), zod.literal(1)])
            .optional()
            .describe("If 1, filter to products that have a manual_score_offset set (admin use)"),
        content_search: zod
            .string()
            .max(getItemsQueryContentSearchMax)
            .optional()
            .describe(
                "Keyword search for product name and selected content fields (general_description\/how_to_use\/ingredients)",
            ),
        content_search_fields: zod
            .string()
            .max(getItemsQueryContentSearchFieldsMax)
            .optional()
            .describe("Comma-separated list of fields to search (general_description, how_to_use, ingredients)"),
        rating: zod
            .union([
                zod.number().min(1).max(getItemsQueryRatingOneMax),
                zod.string().regex(getItemsQueryRatingTwoRegExp),
            ])
            .optional()
            .describe("Rating bucket(s) (1-5). Accepts comma-separated values (e.g. 4 or 4,5)."),
        updated_by: zod
            .string()
            .max(getItemsQueryUpdatedByMax)
            .regex(getItemsQueryUpdatedByRegExp)
            .optional()
            .describe("Filter by updated_by user id(s), comma-separated (admin\/editor only)"),
        updated_at_from: zod
            .string()
            .datetime({ offset: true })
            .optional()
            .describe("Filter by updated_at >= this UTC timestamp (ISO-8601)"),
        updated_at_to: zod
            .string()
            .datetime({ offset: true })
            .optional()
            .describe("Filter by updated_at <= this UTC timestamp (ISO-8601)"),
        product_status: zod
            .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
            .optional()
            .describe("Filter by product status (admin\/editor only)"),
        status: zod
            .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy"])
            .optional()
            .describe("Alias of `product_status` (admin\/editor only)"),
    })
    .strict();

export const GetItemsHeader = zod
    .object({
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const getItems200ResponseDataItemOneProductStatusDefault = `draft`;
export const getItems200ResponseDataItemOneProductNameMax = 255;

export const getItems200ResponseDataItemOneProductUrlMax = 2048;

export const getItems200ResponseDataItemOnePriceUnitMax = 10;

export const getItems200ResponseDataItemOneParentCategoryNameMax = 100;

export const getItems200ResponseDataItemOneBrandNameMax = 100;

export const getItems200ResponseDataItemOneCategoryNameMax = 100;

export const getItems200ResponseDataItemOneUnitMax = 100;

export const getItems200ResponseDataItemOneKeywordMax = 500;

export const getItems200ResponseDataItemTwoReviewSummaryEnMax = 500;

export const getItems200ResponseDataItemTwoReviewSummaryJaMax = 500;

export const getItems200ResponseDataItemTwoRecommendRankMax = 15;

export const getItems200ResponseDataItemTwoManualScoreOffsetMin = 0;
export const getItems200ResponseDataItemTwoManualScoreOffsetMax = 100;

export const getItems200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextThMax = 200;

export const getItems200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextEnMax = 200;

export const getItems200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextJaMax = 200;

export const getItems200ResponseDataItemTwoCategoryCategoryNameMax = 100;

export const getItems200ResponseDataItemTwoCategoryCategoryIconMax = 40;

export const getItems200ResponseDataItemTwoCategoryParentCategoryNameMax = 100;

export const getItems200ResponseDataItemTwoBrandBrandIndexMax = 5;

export const getItems200ResponseDataItemTwoBrandBrandNameMax = 100;

export const getItems200ResponseDataItemTwoBrandCountryMax = 100;

export const getItems200ResponseDataItemTwoBrandWebsiteMax = 1024;

export const getItems200ResponseDataItemTwoReviewsItemPostTitleMax = 300;

export const getItems200ResponseDataItemTwoReviewsItemUserDisplayNameMax = 50;

export const getItems200ResponseDataItemTwoReviewsItemUserFirstNameMax = 100;

export const getItems200ResponseDataItemTwoReviewsItemUserLastNameMax = 100;

export const getItems200ResponseDataItemTwoReviewsItemUserNickNameMax = 50;

export const getItems200ResponseDataItemTwoReviewsItemUserPreferredPriceRangeMax = 50;

export const getItems200ResponseDataItemTwoReviewsItemUserSocialInstagramMax = 100;

export const getItems200ResponseDataItemTwoReviewsItemUserSocialFacebookMax = 100;

export const getItems200ResponseDataItemTwoReviewsItemUserSocialXMax = 100;

export const getItems200ResponseDataItemTwoReviewsItemUserSocialTiktokMax = 100;

export const getItems200ResponseDataItemTwoReviewsItemUserSocialYoutubeMax = 100;

export const getItems200ResponseDataItemTwoReviewsItemUserSocialWebsiteMax = 500;

export const getItems200ResponseDataItemTwoReviewsItemUserAvatarMax = 255;

export const getItems200ResponseDataItemTwoReviewsItemManualScoreOffsetMin = 0;
export const getItems200ResponseDataItemTwoReviewsItemManualScoreOffsetMax = 100;

export const getItems200ResponseTrendingProductsItemOneProductStatusDefault = `draft`;
export const getItems200ResponseTrendingProductsItemOneProductNameMax = 255;

export const getItems200ResponseTrendingProductsItemOneProductUrlMax = 2048;

export const getItems200ResponseTrendingProductsItemOnePriceUnitMax = 10;

export const getItems200ResponseTrendingProductsItemOneParentCategoryNameMax = 100;

export const getItems200ResponseTrendingProductsItemOneBrandNameMax = 100;

export const getItems200ResponseTrendingProductsItemOneCategoryNameMax = 100;

export const getItems200ResponseTrendingProductsItemOneUnitMax = 100;

export const getItems200ResponseTrendingProductsItemOneKeywordMax = 500;

export const getItems200ResponseTrendingProductsItemTwoReviewSummaryEnMax = 500;

export const getItems200ResponseTrendingProductsItemTwoReviewSummaryJaMax = 500;

export const getItems200ResponseTrendingProductsItemTwoRecommendRankMax = 15;

export const getItems200ResponseTrendingProductsItemTwoManualScoreOffsetMin = 0;
export const getItems200ResponseTrendingProductsItemTwoManualScoreOffsetMax = 100;

export const getItems200ResponseTrendingProductsItemTwoReviewQuestionAveragesItemQuestionTextThMax = 200;

export const getItems200ResponseTrendingProductsItemTwoReviewQuestionAveragesItemQuestionTextEnMax = 200;

export const getItems200ResponseTrendingProductsItemTwoReviewQuestionAveragesItemQuestionTextJaMax = 200;

export const getItems200ResponseTrendingProductsItemTwoCategoryCategoryNameMax = 100;

export const getItems200ResponseTrendingProductsItemTwoCategoryCategoryIconMax = 40;

export const getItems200ResponseTrendingProductsItemTwoCategoryParentCategoryNameMax = 100;

export const getItems200ResponseTrendingProductsItemTwoBrandBrandIndexMax = 5;

export const getItems200ResponseTrendingProductsItemTwoBrandBrandNameMax = 100;

export const getItems200ResponseTrendingProductsItemTwoBrandCountryMax = 100;

export const getItems200ResponseTrendingProductsItemTwoBrandWebsiteMax = 1024;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemPostTitleMax = 300;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserDisplayNameMax = 50;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserFirstNameMax = 100;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserLastNameMax = 100;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserNickNameMax = 50;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserPreferredPriceRangeMax = 50;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialInstagramMax = 100;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialFacebookMax = 100;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialXMax = 100;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialTiktokMax = 100;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialYoutubeMax = 100;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialWebsiteMax = 500;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemUserAvatarMax = 255;

export const getItems200ResponseTrendingProductsItemTwoReviewsItemManualScoreOffsetMin = 0;
export const getItems200ResponseTrendingProductsItemTwoReviewsItemManualScoreOffsetMax = 100;

export const GetItems200Response = zod
    .object({
        success: zod
            .union([zod.literal(0), zod.literal(1)])
            .optional()
            .describe("Success flag"),
        data: zod
            .array(
                zod
                    .object({
                        product_id: zod.number().optional().describe("Unique product identifier"),
                        product_status: zod
                            .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
                            .default(getItems200ResponseDataItemOneProductStatusDefault)
                            .describe("Product publication status"),
                        product_name: zod
                            .string()
                            .max(getItems200ResponseDataItemOneProductNameMax)
                            .optional()
                            .describe("Product name (English only)"),
                        product_note: zod
                            .string()
                            .optional()
                            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                        created_by: zod.number().nullish().describe("User ID who created this product (audit)"),
                        updated_by: zod.number().nullish().describe("User ID who last updated this product (audit)"),
                        product_url: zod
                            .string()
                            .max(getItems200ResponseDataItemOneProductUrlMax)
                            .optional()
                            .describe("Product URL"),
                        general_description: zod.string().optional().describe("Product description"),
                        price: zod.number().nullish().describe("Product price"),
                        price_unit: zod
                            .string()
                            .max(getItems200ResponseDataItemOnePriceUnitMax)
                            .optional()
                            .describe("Price unit (e.g., THB, USD)"),
                        image: zod.string().optional().describe("Product image URL"),
                        category_id: zod.number().nullish().describe("Category ID (foreign key)"),
                        parent_category_id: zod
                            .number()
                            .nullish()
                            .describe("Parent category ID (derived from category_id)"),
                        parent_category_name: zod
                            .string()
                            .max(getItems200ResponseDataItemOneParentCategoryNameMax)
                            .optional()
                            .describe("Parent category name (flattened for client convenience)"),
                        brand_id: zod.number().nullish().describe("Brand ID (foreign key)"),
                        brand_name: zod
                            .string()
                            .max(getItems200ResponseDataItemOneBrandNameMax)
                            .optional()
                            .describe("Brand name (flattened for client convenience)"),
                        category_name: zod
                            .string()
                            .max(getItems200ResponseDataItemOneCategoryNameMax)
                            .optional()
                            .describe("Category name (flattened for client convenience)"),
                        group_id: zod
                            .union([
                                zod.number().describe("Product group identifier"),
                                zod.string().describe("Product group identifier"),
                            ])
                            .nullish(),
                        likes_count: zod.number().nullish().describe("Number of likes"),
                        comments_count: zod.number().nullish().describe("Number of comments"),
                        reads_count: zod.number().nullish().describe("Number of reads"),
                        unit: zod
                            .string()
                            .max(getItems200ResponseDataItemOneUnitMax)
                            .optional()
                            .describe("Product unit (e.g., piece, bottle, box)"),
                        keyword: zod
                            .string()
                            .max(getItems200ResponseDataItemOneKeywordMax)
                            .optional()
                            .describe("Search keyword(s)"),
                        how_to_use: zod.string().optional().describe("Usage instructions"),
                        ingredients: zod.string().optional().describe("Ingredients \/ raw materials"),
                        positive_points_th: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (Thai)"),
                        negative_points_th: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (Thai)"),
                        positive_points_en: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (English)"),
                        negative_points_en: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (English)"),
                        positive_points_ja: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (Japanese)"),
                        negative_points_ja: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (Japanese)"),
                        review_summary_th: zod.string().optional().describe("Thai review summary"),
                        review_summary_en: zod
                            .string()
                            .max(getItems200ResponseDataItemTwoReviewSummaryEnMax)
                            .optional()
                            .describe("English review summary"),
                        review_summary_ja: zod
                            .string()
                            .max(getItems200ResponseDataItemTwoReviewSummaryJaMax)
                            .optional()
                            .describe("Japanese review summary"),
                        created_at: zod.string().datetime({ offset: true }).optional().describe("Creation timestamp"),
                        updated_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Last update timestamp"),
                        image_url: zod.string().optional().describe("Canonical absolute image URL"),
                        likes: zod.array(zod.object({}).passthrough()).optional(),
                        comments: zod.array(zod.object({}).passthrough()).optional(),
                        recommend_rank: zod
                            .number()
                            .min(1)
                            .max(getItems200ResponseDataItemTwoRecommendRankMax)
                            .nullish()
                            .describe("Recommend rank for crown display (ISS:04-047)"),
                        monthly_rank: zod
                            .number()
                            .min(1)
                            .nullish()
                            .describe(
                                "Monthly ranking rank (materialized; previous month based on real date) (ISS:04-048)",
                            ),
                        manual_score_offset: zod
                            .number()
                            .min(getItems200ResponseDataItemTwoManualScoreOffsetMin)
                            .max(getItems200ResponseDataItemTwoManualScoreOffsetMax)
                            .nullish()
                            .describe(
                                "Manual score offset added to monthly metric value to stabilize ranking (ISS:05-014)",
                            ),
                        review_count: zod.number().nullish().describe("Total number of reviews for this product"),
                        review_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing review_count — 0 when a guest can't browse to this product (draft\/rejected\/dummy\/duplicated\/brand-placeholder status; equals review_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        posts_count: zod
                            .number()
                            .nullish()
                            .describe(
                                "Total number of posts for this product, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                            ),
                        posts_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing posts_count — 0 when a guest can't browse to this product (same basis as review_count_guest; equals posts_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        average_rating: zod.number().nullish().describe("Average rating from all reviews (1-5 scale)"),
                        likes_by_post: zod
                            .record(zod.string(), zod.array(zod.object({}).passthrough()))
                            .optional()
                            .describe("Likes grouped by post ID for list\/detail convenience"),
                        comments_by_post: zod
                            .record(zod.string(), zod.array(zod.object({}).passthrough()))
                            .optional()
                            .describe("Comments grouped by post ID for list\/detail convenience"),
                        review_question_averages: zod
                            .array(
                                zod
                                    .object({
                                        review_question_id: zod.number().optional().describe("Review question ID"),
                                        average: zod
                                            .number()
                                            .nullish()
                                            .describe("Average score for the review question"),
                                        count: zod
                                            .number()
                                            .optional()
                                            .describe("Number of reviews included in the average"),
                                        data_type: zod
                                            .enum(["rating", "text", "single_select", "multi_select"])
                                            .optional()
                                            .describe("Review question data type"),
                                        question_text_th: zod
                                            .string()
                                            .max(
                                                getItems200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextThMax,
                                            )
                                            .optional()
                                            .describe("Review question text in Thai"),
                                        question_text_en: zod
                                            .string()
                                            .max(
                                                getItems200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextEnMax,
                                            )
                                            .optional()
                                            .describe("Review question text in English"),
                                        question_text_ja: zod
                                            .string()
                                            .max(
                                                getItems200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextJaMax,
                                            )
                                            .optional()
                                            .describe("Review question text in Japanese"),
                                    })
                                    .strict(),
                            )
                            .optional()
                            .describe("Average rating by review question for the product detail view"),
                        category: zod
                            .object({
                                category_id: zod.number().nullish().describe("Category ID"),
                                category_name: zod
                                    .string()
                                    .max(getItems200ResponseDataItemTwoCategoryCategoryNameMax)
                                    .optional()
                                    .describe("Category name"),
                                category_icon: zod
                                    .string()
                                    .max(getItems200ResponseDataItemTwoCategoryCategoryIconMax)
                                    .optional()
                                    .describe(
                                        "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                    ),
                                parent_category_id: zod.number().nullish().describe("Parent category ID"),
                                parent_category_name: zod
                                    .string()
                                    .max(getItems200ResponseDataItemTwoCategoryParentCategoryNameMax)
                                    .optional()
                                    .describe("Parent category name"),
                                display_order: zod.number().optional().describe("Display order"),
                            })
                            .strict()
                            .nullish()
                            .describe("Category information"),
                        brand: zod
                            .object({
                                brand_id: zod.number().nullish().describe("Brand ID"),
                                brand_index: zod
                                    .string()
                                    .max(getItems200ResponseDataItemTwoBrandBrandIndexMax)
                                    .optional()
                                    .describe("Brand index code"),
                                brand_name: zod
                                    .string()
                                    .max(getItems200ResponseDataItemTwoBrandBrandNameMax)
                                    .optional()
                                    .describe("Brand name"),
                                image_url: zod.string().optional().describe("Brand logo\/icon URL"),
                                brand_description_th: zod.string().optional().describe("Brand description in Thai"),
                                brand_description_en: zod.string().optional().describe("Brand description in English"),
                                brand_description_ja: zod.string().optional().describe("Brand description in Japanese"),
                                country: zod
                                    .string()
                                    .max(getItems200ResponseDataItemTwoBrandCountryMax)
                                    .optional()
                                    .describe("Brand country of origin"),
                                website: zod
                                    .string()
                                    .max(getItems200ResponseDataItemTwoBrandWebsiteMax)
                                    .optional()
                                    .describe("Brand official website"),
                            })
                            .strict()
                            .nullish()
                            .describe("Brand information"),
                        reviews: zod
                            .array(
                                zod
                                    .object({
                                        post_id: zod.number().optional().describe("Post ID"),
                                        board_id: zod
                                            .enum([
                                                "review",
                                                "tiktoks",
                                                "beauty_news",
                                                "editorial_reviews",
                                                "expert_reviews",
                                                "activities",
                                                "test_modal",
                                                "test_modeless",
                                                "guidance",
                                            ])
                                            .optional()
                                            .describe("Board ID (should be 'review')"),
                                        post_product_id: zod
                                            .union([
                                                zod.number().describe("Associated product ID on the post record"),
                                                zod.string().describe("Associated product ID on the post record"),
                                            ])
                                            .nullish(),
                                        user_id: zod.number().optional().describe("User ID who created the review"),
                                        post_title: zod
                                            .string()
                                            .max(getItems200ResponseDataItemTwoReviewsItemPostTitleMax)
                                            .optional()
                                            .describe("Review title"),
                                        content: zod.string().optional().describe("Review content"),
                                        attached_images: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Attached image filenames"),
                                        attached_videos: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Attached video filenames"),
                                        content_images: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Images extracted from content"),
                                        created_at: zod
                                            .string()
                                            .datetime({ offset: true })
                                            .optional()
                                            .describe("Creation timestamp"),
                                        updated_at: zod
                                            .string()
                                            .datetime({ offset: true })
                                            .optional()
                                            .describe("Last update timestamp"),
                                        user: zod
                                            .object({
                                                user_id: zod.number().optional(),
                                                username: zod.string().optional(),
                                                display_name: zod
                                                    .string()
                                                    .max(getItems200ResponseDataItemTwoReviewsItemUserDisplayNameMax)
                                                    .optional(),
                                                first_name: zod
                                                    .string()
                                                    .max(getItems200ResponseDataItemTwoReviewsItemUserFirstNameMax)
                                                    .optional(),
                                                last_name: zod
                                                    .string()
                                                    .max(getItems200ResponseDataItemTwoReviewsItemUserLastNameMax)
                                                    .optional(),
                                                nick_name: zod
                                                    .string()
                                                    .max(getItems200ResponseDataItemTwoReviewsItemUserNickNameMax)
                                                    .optional(),
                                                date_of_birth: zod.string().date().nullish(),
                                                gender: zod
                                                    .enum(["male", "female", "other", "prefer_not_to_say"])
                                                    .nullish(),
                                                skin_type: zod
                                                    .enum([
                                                        "normal",
                                                        "oily",
                                                        "dry",
                                                        "combination",
                                                        "sensitive",
                                                        "dehydrated_oily",
                                                        "not_sure",
                                                    ])
                                                    .nullish(),
                                                skin_concerns: zod.array(zod.string()).optional(),
                                                skin_tone: zod
                                                    .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                                    .nullish(),
                                                hair_type: zod
                                                    .enum([
                                                        "straight_coarse",
                                                        "straight_soft",
                                                        "wavy_coarse",
                                                        "wavy_soft",
                                                        "normal_hair",
                                                        "not_sure",
                                                    ])
                                                    .nullish(),
                                                hair_scalp_concerns: zod.array(zod.string()).optional(),
                                                beauty_wellness_interests: zod.array(zod.string()).optional(),
                                                lifestyle_environment: zod.array(zod.string()).optional(),
                                                makeup_frequency: zod
                                                    .enum(["every_day", "occasionally", "rarely"])
                                                    .nullish(),
                                                preferred_price_range: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseDataItemTwoReviewsItemUserPreferredPriceRangeMax,
                                                    )
                                                    .optional(),
                                                social_instagram: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseDataItemTwoReviewsItemUserSocialInstagramMax,
                                                    )
                                                    .optional(),
                                                social_facebook: zod
                                                    .string()
                                                    .max(getItems200ResponseDataItemTwoReviewsItemUserSocialFacebookMax)
                                                    .optional(),
                                                social_x: zod
                                                    .string()
                                                    .max(getItems200ResponseDataItemTwoReviewsItemUserSocialXMax)
                                                    .optional(),
                                                social_tiktok: zod
                                                    .string()
                                                    .max(getItems200ResponseDataItemTwoReviewsItemUserSocialTiktokMax)
                                                    .optional(),
                                                social_youtube: zod
                                                    .string()
                                                    .max(getItems200ResponseDataItemTwoReviewsItemUserSocialYoutubeMax)
                                                    .optional(),
                                                social_website: zod
                                                    .string()
                                                    .max(getItems200ResponseDataItemTwoReviewsItemUserSocialWebsiteMax)
                                                    .optional(),
                                                avatar: zod
                                                    .string()
                                                    .max(getItems200ResponseDataItemTwoReviewsItemUserAvatarMax)
                                                    .optional(),
                                                role: zod
                                                    .enum(["admin", "editor", "moderator", "expert", "user"])
                                                    .optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                recommend_rank: zod.number().nullish(),
                                                posts_count: zod.number().nullish(),
                                                review_count: zod.number().nullish(),
                                                followers_count: zod.number().optional(),
                                                followings_count: zod.number().optional(),
                                            })
                                            .strict()
                                            .optional()
                                            .describe("User information"),
                                        review_data: zod
                                            .object({
                                                review_answer_id: zod.number().optional(),
                                                review_config_id: zod.union([zod.number(), zod.string()]).optional(),
                                                post_id: zod.number().optional(),
                                                answers: zod.array(zod.object({}).passthrough()).optional(),
                                            })
                                            .strict()
                                            .optional()
                                            .describe("Review answer data from ReviewAnswers"),
                                        delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                        reads_count: zod.number().nullish(),
                                        sns_links: zod.array(zod.string().url()).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        monthly_rank: zod.number().nullish(),
                                        manual_score_offset: zod
                                            .number()
                                            .min(getItems200ResponseDataItemTwoReviewsItemManualScoreOffsetMin)
                                            .max(getItems200ResponseDataItemTwoReviewsItemManualScoreOffsetMax)
                                            .nullish(),
                                        sns_shares: zod.array(zod.enum(["instagram", "tiktok"])).optional(),
                                        board: zod.record(zod.string(), zod.unknown()).optional(),
                                        likes: zod.array(zod.object({}).passthrough()).optional(),
                                        reads: zod.array(zod.object({}).passthrough()).optional(),
                                        comments: zod.array(zod.object({}).passthrough()).optional(),
                                        review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        reviews_count: zod.number().optional(),
                                        average_rating: zod.number().nullish(),
                                        rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                        has_user_reviewed: zod.boolean().optional(),
                                        review_config: zod.record(zod.string(), zod.unknown()).nullish(),
                                        review_questions: zod.array(zod.record(zod.string(), zod.unknown())).optional(),
                                        likes_count: zod.number().nullish().describe("Number of likes"),
                                        is_liked_by_current_user: zod
                                            .boolean()
                                            .optional()
                                            .describe("Whether current user has liked this product"),
                                        comments_count: zod.number().nullish().describe("Number of comments"),
                                    })
                                    .strict()
                                    .describe("Review post with enriched user, likes, comments, and reads data"),
                            )
                            .optional()
                            .describe("Product reviews with enriched data"),
                    })
                    .strict(),
            )
            .optional(),
        trending_products: zod
            .array(
                zod
                    .object({
                        product_id: zod.number().optional().describe("Unique product identifier"),
                        product_status: zod
                            .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
                            .default(getItems200ResponseTrendingProductsItemOneProductStatusDefault)
                            .describe("Product publication status"),
                        product_name: zod
                            .string()
                            .max(getItems200ResponseTrendingProductsItemOneProductNameMax)
                            .optional()
                            .describe("Product name (English only)"),
                        product_note: zod
                            .string()
                            .optional()
                            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                        created_by: zod.number().nullish().describe("User ID who created this product (audit)"),
                        updated_by: zod.number().nullish().describe("User ID who last updated this product (audit)"),
                        product_url: zod
                            .string()
                            .max(getItems200ResponseTrendingProductsItemOneProductUrlMax)
                            .optional()
                            .describe("Product URL"),
                        general_description: zod.string().optional().describe("Product description"),
                        price: zod.number().nullish().describe("Product price"),
                        price_unit: zod
                            .string()
                            .max(getItems200ResponseTrendingProductsItemOnePriceUnitMax)
                            .optional()
                            .describe("Price unit (e.g., THB, USD)"),
                        image: zod.string().optional().describe("Product image URL"),
                        category_id: zod.number().nullish().describe("Category ID (foreign key)"),
                        parent_category_id: zod
                            .number()
                            .nullish()
                            .describe("Parent category ID (derived from category_id)"),
                        parent_category_name: zod
                            .string()
                            .max(getItems200ResponseTrendingProductsItemOneParentCategoryNameMax)
                            .optional()
                            .describe("Parent category name (flattened for client convenience)"),
                        brand_id: zod.number().nullish().describe("Brand ID (foreign key)"),
                        brand_name: zod
                            .string()
                            .max(getItems200ResponseTrendingProductsItemOneBrandNameMax)
                            .optional()
                            .describe("Brand name (flattened for client convenience)"),
                        category_name: zod
                            .string()
                            .max(getItems200ResponseTrendingProductsItemOneCategoryNameMax)
                            .optional()
                            .describe("Category name (flattened for client convenience)"),
                        group_id: zod
                            .union([
                                zod.number().describe("Product group identifier"),
                                zod.string().describe("Product group identifier"),
                            ])
                            .nullish(),
                        likes_count: zod.number().nullish().describe("Number of likes"),
                        comments_count: zod.number().nullish().describe("Number of comments"),
                        reads_count: zod.number().nullish().describe("Number of reads"),
                        unit: zod
                            .string()
                            .max(getItems200ResponseTrendingProductsItemOneUnitMax)
                            .optional()
                            .describe("Product unit (e.g., piece, bottle, box)"),
                        keyword: zod
                            .string()
                            .max(getItems200ResponseTrendingProductsItemOneKeywordMax)
                            .optional()
                            .describe("Search keyword(s)"),
                        how_to_use: zod.string().optional().describe("Usage instructions"),
                        ingredients: zod.string().optional().describe("Ingredients \/ raw materials"),
                        positive_points_th: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (Thai)"),
                        negative_points_th: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (Thai)"),
                        positive_points_en: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (English)"),
                        negative_points_en: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (English)"),
                        positive_points_ja: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (Japanese)"),
                        negative_points_ja: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (Japanese)"),
                        review_summary_th: zod.string().optional().describe("Thai review summary"),
                        review_summary_en: zod
                            .string()
                            .max(getItems200ResponseTrendingProductsItemTwoReviewSummaryEnMax)
                            .optional()
                            .describe("English review summary"),
                        review_summary_ja: zod
                            .string()
                            .max(getItems200ResponseTrendingProductsItemTwoReviewSummaryJaMax)
                            .optional()
                            .describe("Japanese review summary"),
                        created_at: zod.string().datetime({ offset: true }).optional().describe("Creation timestamp"),
                        updated_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Last update timestamp"),
                        image_url: zod.string().optional().describe("Canonical absolute image URL"),
                        likes: zod.array(zod.object({}).passthrough()).optional(),
                        comments: zod.array(zod.object({}).passthrough()).optional(),
                        recommend_rank: zod
                            .number()
                            .min(1)
                            .max(getItems200ResponseTrendingProductsItemTwoRecommendRankMax)
                            .nullish()
                            .describe("Recommend rank for crown display (ISS:04-047)"),
                        monthly_rank: zod
                            .number()
                            .min(1)
                            .nullish()
                            .describe(
                                "Monthly ranking rank (materialized; previous month based on real date) (ISS:04-048)",
                            ),
                        manual_score_offset: zod
                            .number()
                            .min(getItems200ResponseTrendingProductsItemTwoManualScoreOffsetMin)
                            .max(getItems200ResponseTrendingProductsItemTwoManualScoreOffsetMax)
                            .nullish()
                            .describe(
                                "Manual score offset added to monthly metric value to stabilize ranking (ISS:05-014)",
                            ),
                        review_count: zod.number().nullish().describe("Total number of reviews for this product"),
                        review_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing review_count — 0 when a guest can't browse to this product (draft\/rejected\/dummy\/duplicated\/brand-placeholder status; equals review_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        posts_count: zod
                            .number()
                            .nullish()
                            .describe(
                                "Total number of posts for this product, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                            ),
                        posts_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing posts_count — 0 when a guest can't browse to this product (same basis as review_count_guest; equals posts_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        average_rating: zod.number().nullish().describe("Average rating from all reviews (1-5 scale)"),
                        likes_by_post: zod
                            .record(zod.string(), zod.array(zod.object({}).passthrough()))
                            .optional()
                            .describe("Likes grouped by post ID for list\/detail convenience"),
                        comments_by_post: zod
                            .record(zod.string(), zod.array(zod.object({}).passthrough()))
                            .optional()
                            .describe("Comments grouped by post ID for list\/detail convenience"),
                        review_question_averages: zod
                            .array(
                                zod
                                    .object({
                                        review_question_id: zod.number().optional().describe("Review question ID"),
                                        average: zod
                                            .number()
                                            .nullish()
                                            .describe("Average score for the review question"),
                                        count: zod
                                            .number()
                                            .optional()
                                            .describe("Number of reviews included in the average"),
                                        data_type: zod
                                            .enum(["rating", "text", "single_select", "multi_select"])
                                            .optional()
                                            .describe("Review question data type"),
                                        question_text_th: zod
                                            .string()
                                            .max(
                                                getItems200ResponseTrendingProductsItemTwoReviewQuestionAveragesItemQuestionTextThMax,
                                            )
                                            .optional()
                                            .describe("Review question text in Thai"),
                                        question_text_en: zod
                                            .string()
                                            .max(
                                                getItems200ResponseTrendingProductsItemTwoReviewQuestionAveragesItemQuestionTextEnMax,
                                            )
                                            .optional()
                                            .describe("Review question text in English"),
                                        question_text_ja: zod
                                            .string()
                                            .max(
                                                getItems200ResponseTrendingProductsItemTwoReviewQuestionAveragesItemQuestionTextJaMax,
                                            )
                                            .optional()
                                            .describe("Review question text in Japanese"),
                                    })
                                    .strict(),
                            )
                            .optional()
                            .describe("Average rating by review question for the product detail view"),
                        category: zod
                            .object({
                                category_id: zod.number().nullish().describe("Category ID"),
                                category_name: zod
                                    .string()
                                    .max(getItems200ResponseTrendingProductsItemTwoCategoryCategoryNameMax)
                                    .optional()
                                    .describe("Category name"),
                                category_icon: zod
                                    .string()
                                    .max(getItems200ResponseTrendingProductsItemTwoCategoryCategoryIconMax)
                                    .optional()
                                    .describe(
                                        "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                    ),
                                parent_category_id: zod.number().nullish().describe("Parent category ID"),
                                parent_category_name: zod
                                    .string()
                                    .max(getItems200ResponseTrendingProductsItemTwoCategoryParentCategoryNameMax)
                                    .optional()
                                    .describe("Parent category name"),
                                display_order: zod.number().optional().describe("Display order"),
                            })
                            .strict()
                            .nullish()
                            .describe("Category information"),
                        brand: zod
                            .object({
                                brand_id: zod.number().nullish().describe("Brand ID"),
                                brand_index: zod
                                    .string()
                                    .max(getItems200ResponseTrendingProductsItemTwoBrandBrandIndexMax)
                                    .optional()
                                    .describe("Brand index code"),
                                brand_name: zod
                                    .string()
                                    .max(getItems200ResponseTrendingProductsItemTwoBrandBrandNameMax)
                                    .optional()
                                    .describe("Brand name"),
                                image_url: zod.string().optional().describe("Brand logo\/icon URL"),
                                brand_description_th: zod.string().optional().describe("Brand description in Thai"),
                                brand_description_en: zod.string().optional().describe("Brand description in English"),
                                brand_description_ja: zod.string().optional().describe("Brand description in Japanese"),
                                country: zod
                                    .string()
                                    .max(getItems200ResponseTrendingProductsItemTwoBrandCountryMax)
                                    .optional()
                                    .describe("Brand country of origin"),
                                website: zod
                                    .string()
                                    .max(getItems200ResponseTrendingProductsItemTwoBrandWebsiteMax)
                                    .optional()
                                    .describe("Brand official website"),
                            })
                            .strict()
                            .nullish()
                            .describe("Brand information"),
                        reviews: zod
                            .array(
                                zod
                                    .object({
                                        post_id: zod.number().optional().describe("Post ID"),
                                        board_id: zod
                                            .enum([
                                                "review",
                                                "tiktoks",
                                                "beauty_news",
                                                "editorial_reviews",
                                                "expert_reviews",
                                                "activities",
                                                "test_modal",
                                                "test_modeless",
                                                "guidance",
                                            ])
                                            .optional()
                                            .describe("Board ID (should be 'review')"),
                                        post_product_id: zod
                                            .union([
                                                zod.number().describe("Associated product ID on the post record"),
                                                zod.string().describe("Associated product ID on the post record"),
                                            ])
                                            .nullish(),
                                        user_id: zod.number().optional().describe("User ID who created the review"),
                                        post_title: zod
                                            .string()
                                            .max(getItems200ResponseTrendingProductsItemTwoReviewsItemPostTitleMax)
                                            .optional()
                                            .describe("Review title"),
                                        content: zod.string().optional().describe("Review content"),
                                        attached_images: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Attached image filenames"),
                                        attached_videos: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Attached video filenames"),
                                        content_images: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Images extracted from content"),
                                        created_at: zod
                                            .string()
                                            .datetime({ offset: true })
                                            .optional()
                                            .describe("Creation timestamp"),
                                        updated_at: zod
                                            .string()
                                            .datetime({ offset: true })
                                            .optional()
                                            .describe("Last update timestamp"),
                                        user: zod
                                            .object({
                                                user_id: zod.number().optional(),
                                                username: zod.string().optional(),
                                                display_name: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserDisplayNameMax,
                                                    )
                                                    .optional(),
                                                first_name: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserFirstNameMax,
                                                    )
                                                    .optional(),
                                                last_name: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserLastNameMax,
                                                    )
                                                    .optional(),
                                                nick_name: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserNickNameMax,
                                                    )
                                                    .optional(),
                                                date_of_birth: zod.string().date().nullish(),
                                                gender: zod
                                                    .enum(["male", "female", "other", "prefer_not_to_say"])
                                                    .nullish(),
                                                skin_type: zod
                                                    .enum([
                                                        "normal",
                                                        "oily",
                                                        "dry",
                                                        "combination",
                                                        "sensitive",
                                                        "dehydrated_oily",
                                                        "not_sure",
                                                    ])
                                                    .nullish(),
                                                skin_concerns: zod.array(zod.string()).optional(),
                                                skin_tone: zod
                                                    .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                                    .nullish(),
                                                hair_type: zod
                                                    .enum([
                                                        "straight_coarse",
                                                        "straight_soft",
                                                        "wavy_coarse",
                                                        "wavy_soft",
                                                        "normal_hair",
                                                        "not_sure",
                                                    ])
                                                    .nullish(),
                                                hair_scalp_concerns: zod.array(zod.string()).optional(),
                                                beauty_wellness_interests: zod.array(zod.string()).optional(),
                                                lifestyle_environment: zod.array(zod.string()).optional(),
                                                makeup_frequency: zod
                                                    .enum(["every_day", "occasionally", "rarely"])
                                                    .nullish(),
                                                preferred_price_range: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserPreferredPriceRangeMax,
                                                    )
                                                    .optional(),
                                                social_instagram: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialInstagramMax,
                                                    )
                                                    .optional(),
                                                social_facebook: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialFacebookMax,
                                                    )
                                                    .optional(),
                                                social_x: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialXMax,
                                                    )
                                                    .optional(),
                                                social_tiktok: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialTiktokMax,
                                                    )
                                                    .optional(),
                                                social_youtube: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialYoutubeMax,
                                                    )
                                                    .optional(),
                                                social_website: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserSocialWebsiteMax,
                                                    )
                                                    .optional(),
                                                avatar: zod
                                                    .string()
                                                    .max(
                                                        getItems200ResponseTrendingProductsItemTwoReviewsItemUserAvatarMax,
                                                    )
                                                    .optional(),
                                                role: zod
                                                    .enum(["admin", "editor", "moderator", "expert", "user"])
                                                    .optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                recommend_rank: zod.number().nullish(),
                                                posts_count: zod.number().nullish(),
                                                review_count: zod.number().nullish(),
                                                followers_count: zod.number().optional(),
                                                followings_count: zod.number().optional(),
                                            })
                                            .strict()
                                            .optional()
                                            .describe("User information"),
                                        review_data: zod
                                            .object({
                                                review_answer_id: zod.number().optional(),
                                                review_config_id: zod.union([zod.number(), zod.string()]).optional(),
                                                post_id: zod.number().optional(),
                                                answers: zod.array(zod.object({}).passthrough()).optional(),
                                            })
                                            .strict()
                                            .optional()
                                            .describe("Review answer data from ReviewAnswers"),
                                        delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                        reads_count: zod.number().nullish(),
                                        sns_links: zod.array(zod.string().url()).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        monthly_rank: zod.number().nullish(),
                                        manual_score_offset: zod
                                            .number()
                                            .min(
                                                getItems200ResponseTrendingProductsItemTwoReviewsItemManualScoreOffsetMin,
                                            )
                                            .max(
                                                getItems200ResponseTrendingProductsItemTwoReviewsItemManualScoreOffsetMax,
                                            )
                                            .nullish(),
                                        sns_shares: zod.array(zod.enum(["instagram", "tiktok"])).optional(),
                                        board: zod.record(zod.string(), zod.unknown()).optional(),
                                        likes: zod.array(zod.object({}).passthrough()).optional(),
                                        reads: zod.array(zod.object({}).passthrough()).optional(),
                                        comments: zod.array(zod.object({}).passthrough()).optional(),
                                        review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        reviews_count: zod.number().optional(),
                                        average_rating: zod.number().nullish(),
                                        rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                        has_user_reviewed: zod.boolean().optional(),
                                        review_config: zod.record(zod.string(), zod.unknown()).nullish(),
                                        review_questions: zod.array(zod.record(zod.string(), zod.unknown())).optional(),
                                        likes_count: zod.number().nullish().describe("Number of likes"),
                                        is_liked_by_current_user: zod
                                            .boolean()
                                            .optional()
                                            .describe("Whether current user has liked this product"),
                                        comments_count: zod.number().nullish().describe("Number of comments"),
                                    })
                                    .strict()
                                    .describe("Review post with enriched user, likes, comments, and reads data"),
                            )
                            .optional()
                            .describe("Product reviews with enriched data"),
                    })
                    .strict(),
            )
            .optional()
            .describe("Recommended products sorted by recommend_rank asc (shown on products page)"),
        pagination: zod
            .object({
                current_page: zod.number().optional(),
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetItems400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

export const GetItems422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Create product (admin/editor only)
 */
export const createItemBodyProductStatusDefault = `draft`;
export const createItemBodyProductNameMax = 255;

export const createItemBodyProductUrlMax = 2048;

export const createItemBodyImageDefault = `media/products/no_image.jpg`;
export const createItemBodyImageMax = 2048;

export const createItemBodyPriceUnitDefault = `THB`;
export const createItemBodyPriceUnitMax = 10;

export const createItemBodyUnitMax = 100;

export const createItemBodyKeywordMax = 500;

export const createItemBodyReviewSummaryEnMax = 500;

export const createItemBodyReviewSummaryJaMax = 500;

export const CreateItemBody = zod
    .object({
        product_status: zod
            .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
            .default(createItemBodyProductStatusDefault)
            .describe("Product status"),
        product_name: zod.string().max(createItemBodyProductNameMax),
        product_url: zod.string().max(createItemBodyProductUrlMax),
        general_description: zod.string().optional(),
        product_note: zod
            .string()
            .optional()
            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
        image: zod.string().max(createItemBodyImageMax).default(createItemBodyImageDefault),
        price: zod.number().nullish(),
        price_unit: zod.string().max(createItemBodyPriceUnitMax).default(createItemBodyPriceUnitDefault),
        category_id: zod.number().nullish(),
        brand_id: zod.number(),
        group_id: zod.union([zod.number(), zod.string()]).nullish(),
        unit: zod.string().max(createItemBodyUnitMax).optional(),
        keyword: zod.string().max(createItemBodyKeywordMax).optional(),
        how_to_use: zod.string().optional(),
        ingredients: zod.string().optional(),
        positive_points_th: zod.array(zod.string()).optional(),
        negative_points_th: zod.array(zod.string()).optional(),
        positive_points_en: zod.array(zod.string()).optional(),
        negative_points_en: zod.array(zod.string()).optional(),
        positive_points_ja: zod.array(zod.string()).optional(),
        negative_points_ja: zod.array(zod.string()).optional(),
        review_summary_th: zod.string().optional(),
        review_summary_en: zod.string().max(createItemBodyReviewSummaryEnMax).optional(),
        review_summary_ja: zod.string().max(createItemBodyReviewSummaryJaMax).optional(),
    })
    .strict();

export const createItem201ResponseDataItemOneProductStatusDefault = `draft`;
export const createItem201ResponseDataItemOneProductNameMax = 255;

export const createItem201ResponseDataItemOneProductUrlMax = 2048;

export const createItem201ResponseDataItemOnePriceUnitMax = 10;

export const createItem201ResponseDataItemOneParentCategoryNameMax = 100;

export const createItem201ResponseDataItemOneBrandNameMax = 100;

export const createItem201ResponseDataItemOneCategoryNameMax = 100;

export const createItem201ResponseDataItemOneUnitMax = 100;

export const createItem201ResponseDataItemOneKeywordMax = 500;

export const createItem201ResponseDataItemTwoReviewSummaryEnMax = 500;

export const createItem201ResponseDataItemTwoReviewSummaryJaMax = 500;

export const createItem201ResponseDataItemTwoRecommendRankMax = 15;

export const createItem201ResponseDataItemTwoManualScoreOffsetMin = 0;
export const createItem201ResponseDataItemTwoManualScoreOffsetMax = 100;

export const createItem201ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextThMax = 200;

export const createItem201ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextEnMax = 200;

export const createItem201ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextJaMax = 200;

export const createItem201ResponseDataItemTwoCategoryCategoryNameMax = 100;

export const createItem201ResponseDataItemTwoCategoryCategoryIconMax = 40;

export const createItem201ResponseDataItemTwoCategoryParentCategoryNameMax = 100;

export const createItem201ResponseDataItemTwoBrandBrandIndexMax = 5;

export const createItem201ResponseDataItemTwoBrandBrandNameMax = 100;

export const createItem201ResponseDataItemTwoBrandCountryMax = 100;

export const createItem201ResponseDataItemTwoBrandWebsiteMax = 1024;

export const createItem201ResponseDataItemTwoReviewsItemPostTitleMax = 300;

export const createItem201ResponseDataItemTwoReviewsItemUserDisplayNameMax = 50;

export const createItem201ResponseDataItemTwoReviewsItemUserFirstNameMax = 100;

export const createItem201ResponseDataItemTwoReviewsItemUserLastNameMax = 100;

export const createItem201ResponseDataItemTwoReviewsItemUserNickNameMax = 50;

export const createItem201ResponseDataItemTwoReviewsItemUserPreferredPriceRangeMax = 50;

export const createItem201ResponseDataItemTwoReviewsItemUserSocialInstagramMax = 100;

export const createItem201ResponseDataItemTwoReviewsItemUserSocialFacebookMax = 100;

export const createItem201ResponseDataItemTwoReviewsItemUserSocialXMax = 100;

export const createItem201ResponseDataItemTwoReviewsItemUserSocialTiktokMax = 100;

export const createItem201ResponseDataItemTwoReviewsItemUserSocialYoutubeMax = 100;

export const createItem201ResponseDataItemTwoReviewsItemUserSocialWebsiteMax = 500;

export const createItem201ResponseDataItemTwoReviewsItemUserAvatarMax = 255;

export const createItem201ResponseDataItemTwoReviewsItemManualScoreOffsetMin = 0;
export const createItem201ResponseDataItemTwoReviewsItemManualScoreOffsetMax = 100;

export const CreateItem201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        product_id: zod.number().optional().describe("Unique product identifier"),
                        product_status: zod
                            .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
                            .default(createItem201ResponseDataItemOneProductStatusDefault)
                            .describe("Product publication status"),
                        product_name: zod
                            .string()
                            .max(createItem201ResponseDataItemOneProductNameMax)
                            .optional()
                            .describe("Product name (English only)"),
                        product_note: zod
                            .string()
                            .optional()
                            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                        created_by: zod.number().nullish().describe("User ID who created this product (audit)"),
                        updated_by: zod.number().nullish().describe("User ID who last updated this product (audit)"),
                        product_url: zod
                            .string()
                            .max(createItem201ResponseDataItemOneProductUrlMax)
                            .optional()
                            .describe("Product URL"),
                        general_description: zod.string().optional().describe("Product description"),
                        price: zod.number().nullish().describe("Product price"),
                        price_unit: zod
                            .string()
                            .max(createItem201ResponseDataItemOnePriceUnitMax)
                            .optional()
                            .describe("Price unit (e.g., THB, USD)"),
                        image: zod.string().optional().describe("Product image URL"),
                        category_id: zod.number().nullish().describe("Category ID (foreign key)"),
                        parent_category_id: zod
                            .number()
                            .nullish()
                            .describe("Parent category ID (derived from category_id)"),
                        parent_category_name: zod
                            .string()
                            .max(createItem201ResponseDataItemOneParentCategoryNameMax)
                            .optional()
                            .describe("Parent category name (flattened for client convenience)"),
                        brand_id: zod.number().nullish().describe("Brand ID (foreign key)"),
                        brand_name: zod
                            .string()
                            .max(createItem201ResponseDataItemOneBrandNameMax)
                            .optional()
                            .describe("Brand name (flattened for client convenience)"),
                        category_name: zod
                            .string()
                            .max(createItem201ResponseDataItemOneCategoryNameMax)
                            .optional()
                            .describe("Category name (flattened for client convenience)"),
                        group_id: zod
                            .union([
                                zod.number().describe("Product group identifier"),
                                zod.string().describe("Product group identifier"),
                            ])
                            .nullish(),
                        likes_count: zod.number().nullish().describe("Number of likes"),
                        comments_count: zod.number().nullish().describe("Number of comments"),
                        reads_count: zod.number().nullish().describe("Number of reads"),
                        unit: zod
                            .string()
                            .max(createItem201ResponseDataItemOneUnitMax)
                            .optional()
                            .describe("Product unit (e.g., piece, bottle, box)"),
                        keyword: zod
                            .string()
                            .max(createItem201ResponseDataItemOneKeywordMax)
                            .optional()
                            .describe("Search keyword(s)"),
                        how_to_use: zod.string().optional().describe("Usage instructions"),
                        ingredients: zod.string().optional().describe("Ingredients \/ raw materials"),
                        positive_points_th: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (Thai)"),
                        negative_points_th: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (Thai)"),
                        positive_points_en: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (English)"),
                        negative_points_en: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (English)"),
                        positive_points_ja: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (Japanese)"),
                        negative_points_ja: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (Japanese)"),
                        review_summary_th: zod.string().optional().describe("Thai review summary"),
                        review_summary_en: zod
                            .string()
                            .max(createItem201ResponseDataItemTwoReviewSummaryEnMax)
                            .optional()
                            .describe("English review summary"),
                        review_summary_ja: zod
                            .string()
                            .max(createItem201ResponseDataItemTwoReviewSummaryJaMax)
                            .optional()
                            .describe("Japanese review summary"),
                        created_at: zod.string().datetime({ offset: true }).optional().describe("Creation timestamp"),
                        updated_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Last update timestamp"),
                        image_url: zod.string().optional().describe("Canonical absolute image URL"),
                        likes: zod.array(zod.object({}).passthrough()).optional(),
                        comments: zod.array(zod.object({}).passthrough()).optional(),
                        recommend_rank: zod
                            .number()
                            .min(1)
                            .max(createItem201ResponseDataItemTwoRecommendRankMax)
                            .nullish()
                            .describe("Recommend rank for crown display (ISS:04-047)"),
                        monthly_rank: zod
                            .number()
                            .min(1)
                            .nullish()
                            .describe(
                                "Monthly ranking rank (materialized; previous month based on real date) (ISS:04-048)",
                            ),
                        manual_score_offset: zod
                            .number()
                            .min(createItem201ResponseDataItemTwoManualScoreOffsetMin)
                            .max(createItem201ResponseDataItemTwoManualScoreOffsetMax)
                            .nullish()
                            .describe(
                                "Manual score offset added to monthly metric value to stabilize ranking (ISS:05-014)",
                            ),
                        review_count: zod.number().nullish().describe("Total number of reviews for this product"),
                        review_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing review_count — 0 when a guest can't browse to this product (draft\/rejected\/dummy\/duplicated\/brand-placeholder status; equals review_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        posts_count: zod
                            .number()
                            .nullish()
                            .describe(
                                "Total number of posts for this product, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                            ),
                        posts_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing posts_count — 0 when a guest can't browse to this product (same basis as review_count_guest; equals posts_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        average_rating: zod.number().nullish().describe("Average rating from all reviews (1-5 scale)"),
                        likes_by_post: zod
                            .record(zod.string(), zod.array(zod.object({}).passthrough()))
                            .optional()
                            .describe("Likes grouped by post ID for list\/detail convenience"),
                        comments_by_post: zod
                            .record(zod.string(), zod.array(zod.object({}).passthrough()))
                            .optional()
                            .describe("Comments grouped by post ID for list\/detail convenience"),
                        review_question_averages: zod
                            .array(
                                zod
                                    .object({
                                        review_question_id: zod.number().optional().describe("Review question ID"),
                                        average: zod
                                            .number()
                                            .nullish()
                                            .describe("Average score for the review question"),
                                        count: zod
                                            .number()
                                            .optional()
                                            .describe("Number of reviews included in the average"),
                                        data_type: zod
                                            .enum(["rating", "text", "single_select", "multi_select"])
                                            .optional()
                                            .describe("Review question data type"),
                                        question_text_th: zod
                                            .string()
                                            .max(
                                                createItem201ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextThMax,
                                            )
                                            .optional()
                                            .describe("Review question text in Thai"),
                                        question_text_en: zod
                                            .string()
                                            .max(
                                                createItem201ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextEnMax,
                                            )
                                            .optional()
                                            .describe("Review question text in English"),
                                        question_text_ja: zod
                                            .string()
                                            .max(
                                                createItem201ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextJaMax,
                                            )
                                            .optional()
                                            .describe("Review question text in Japanese"),
                                    })
                                    .strict(),
                            )
                            .optional()
                            .describe("Average rating by review question for the product detail view"),
                        category: zod
                            .object({
                                category_id: zod.number().nullish().describe("Category ID"),
                                category_name: zod
                                    .string()
                                    .max(createItem201ResponseDataItemTwoCategoryCategoryNameMax)
                                    .optional()
                                    .describe("Category name"),
                                category_icon: zod
                                    .string()
                                    .max(createItem201ResponseDataItemTwoCategoryCategoryIconMax)
                                    .optional()
                                    .describe(
                                        "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                    ),
                                parent_category_id: zod.number().nullish().describe("Parent category ID"),
                                parent_category_name: zod
                                    .string()
                                    .max(createItem201ResponseDataItemTwoCategoryParentCategoryNameMax)
                                    .optional()
                                    .describe("Parent category name"),
                                display_order: zod.number().optional().describe("Display order"),
                            })
                            .strict()
                            .nullish()
                            .describe("Category information"),
                        brand: zod
                            .object({
                                brand_id: zod.number().nullish().describe("Brand ID"),
                                brand_index: zod
                                    .string()
                                    .max(createItem201ResponseDataItemTwoBrandBrandIndexMax)
                                    .optional()
                                    .describe("Brand index code"),
                                brand_name: zod
                                    .string()
                                    .max(createItem201ResponseDataItemTwoBrandBrandNameMax)
                                    .optional()
                                    .describe("Brand name"),
                                image_url: zod.string().optional().describe("Brand logo\/icon URL"),
                                brand_description_th: zod.string().optional().describe("Brand description in Thai"),
                                brand_description_en: zod.string().optional().describe("Brand description in English"),
                                brand_description_ja: zod.string().optional().describe("Brand description in Japanese"),
                                country: zod
                                    .string()
                                    .max(createItem201ResponseDataItemTwoBrandCountryMax)
                                    .optional()
                                    .describe("Brand country of origin"),
                                website: zod
                                    .string()
                                    .max(createItem201ResponseDataItemTwoBrandWebsiteMax)
                                    .optional()
                                    .describe("Brand official website"),
                            })
                            .strict()
                            .nullish()
                            .describe("Brand information"),
                        reviews: zod
                            .array(
                                zod
                                    .object({
                                        post_id: zod.number().optional().describe("Post ID"),
                                        board_id: zod
                                            .enum([
                                                "review",
                                                "tiktoks",
                                                "beauty_news",
                                                "editorial_reviews",
                                                "expert_reviews",
                                                "activities",
                                                "test_modal",
                                                "test_modeless",
                                                "guidance",
                                            ])
                                            .optional()
                                            .describe("Board ID (should be 'review')"),
                                        post_product_id: zod
                                            .union([
                                                zod.number().describe("Associated product ID on the post record"),
                                                zod.string().describe("Associated product ID on the post record"),
                                            ])
                                            .nullish(),
                                        user_id: zod.number().optional().describe("User ID who created the review"),
                                        post_title: zod
                                            .string()
                                            .max(createItem201ResponseDataItemTwoReviewsItemPostTitleMax)
                                            .optional()
                                            .describe("Review title"),
                                        content: zod.string().optional().describe("Review content"),
                                        attached_images: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Attached image filenames"),
                                        attached_videos: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Attached video filenames"),
                                        content_images: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Images extracted from content"),
                                        created_at: zod
                                            .string()
                                            .datetime({ offset: true })
                                            .optional()
                                            .describe("Creation timestamp"),
                                        updated_at: zod
                                            .string()
                                            .datetime({ offset: true })
                                            .optional()
                                            .describe("Last update timestamp"),
                                        user: zod
                                            .object({
                                                user_id: zod.number().optional(),
                                                username: zod.string().optional(),
                                                display_name: zod
                                                    .string()
                                                    .max(createItem201ResponseDataItemTwoReviewsItemUserDisplayNameMax)
                                                    .optional(),
                                                first_name: zod
                                                    .string()
                                                    .max(createItem201ResponseDataItemTwoReviewsItemUserFirstNameMax)
                                                    .optional(),
                                                last_name: zod
                                                    .string()
                                                    .max(createItem201ResponseDataItemTwoReviewsItemUserLastNameMax)
                                                    .optional(),
                                                nick_name: zod
                                                    .string()
                                                    .max(createItem201ResponseDataItemTwoReviewsItemUserNickNameMax)
                                                    .optional(),
                                                date_of_birth: zod.string().date().nullish(),
                                                gender: zod
                                                    .enum(["male", "female", "other", "prefer_not_to_say"])
                                                    .nullish(),
                                                skin_type: zod
                                                    .enum([
                                                        "normal",
                                                        "oily",
                                                        "dry",
                                                        "combination",
                                                        "sensitive",
                                                        "dehydrated_oily",
                                                        "not_sure",
                                                    ])
                                                    .nullish(),
                                                skin_concerns: zod.array(zod.string()).optional(),
                                                skin_tone: zod
                                                    .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                                    .nullish(),
                                                hair_type: zod
                                                    .enum([
                                                        "straight_coarse",
                                                        "straight_soft",
                                                        "wavy_coarse",
                                                        "wavy_soft",
                                                        "normal_hair",
                                                        "not_sure",
                                                    ])
                                                    .nullish(),
                                                hair_scalp_concerns: zod.array(zod.string()).optional(),
                                                beauty_wellness_interests: zod.array(zod.string()).optional(),
                                                lifestyle_environment: zod.array(zod.string()).optional(),
                                                makeup_frequency: zod
                                                    .enum(["every_day", "occasionally", "rarely"])
                                                    .nullish(),
                                                preferred_price_range: zod
                                                    .string()
                                                    .max(
                                                        createItem201ResponseDataItemTwoReviewsItemUserPreferredPriceRangeMax,
                                                    )
                                                    .optional(),
                                                social_instagram: zod
                                                    .string()
                                                    .max(
                                                        createItem201ResponseDataItemTwoReviewsItemUserSocialInstagramMax,
                                                    )
                                                    .optional(),
                                                social_facebook: zod
                                                    .string()
                                                    .max(
                                                        createItem201ResponseDataItemTwoReviewsItemUserSocialFacebookMax,
                                                    )
                                                    .optional(),
                                                social_x: zod
                                                    .string()
                                                    .max(createItem201ResponseDataItemTwoReviewsItemUserSocialXMax)
                                                    .optional(),
                                                social_tiktok: zod
                                                    .string()
                                                    .max(createItem201ResponseDataItemTwoReviewsItemUserSocialTiktokMax)
                                                    .optional(),
                                                social_youtube: zod
                                                    .string()
                                                    .max(
                                                        createItem201ResponseDataItemTwoReviewsItemUserSocialYoutubeMax,
                                                    )
                                                    .optional(),
                                                social_website: zod
                                                    .string()
                                                    .max(
                                                        createItem201ResponseDataItemTwoReviewsItemUserSocialWebsiteMax,
                                                    )
                                                    .optional(),
                                                avatar: zod
                                                    .string()
                                                    .max(createItem201ResponseDataItemTwoReviewsItemUserAvatarMax)
                                                    .optional(),
                                                role: zod
                                                    .enum(["admin", "editor", "moderator", "expert", "user"])
                                                    .optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                recommend_rank: zod.number().nullish(),
                                                posts_count: zod.number().nullish(),
                                                review_count: zod.number().nullish(),
                                                followers_count: zod.number().optional(),
                                                followings_count: zod.number().optional(),
                                            })
                                            .strict()
                                            .optional()
                                            .describe("User information"),
                                        review_data: zod
                                            .object({
                                                review_answer_id: zod.number().optional(),
                                                review_config_id: zod.union([zod.number(), zod.string()]).optional(),
                                                post_id: zod.number().optional(),
                                                answers: zod.array(zod.object({}).passthrough()).optional(),
                                            })
                                            .strict()
                                            .optional()
                                            .describe("Review answer data from ReviewAnswers"),
                                        delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                        reads_count: zod.number().nullish(),
                                        sns_links: zod.array(zod.string().url()).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        monthly_rank: zod.number().nullish(),
                                        manual_score_offset: zod
                                            .number()
                                            .min(createItem201ResponseDataItemTwoReviewsItemManualScoreOffsetMin)
                                            .max(createItem201ResponseDataItemTwoReviewsItemManualScoreOffsetMax)
                                            .nullish(),
                                        sns_shares: zod.array(zod.enum(["instagram", "tiktok"])).optional(),
                                        board: zod.record(zod.string(), zod.unknown()).optional(),
                                        likes: zod.array(zod.object({}).passthrough()).optional(),
                                        reads: zod.array(zod.object({}).passthrough()).optional(),
                                        comments: zod.array(zod.object({}).passthrough()).optional(),
                                        review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        reviews_count: zod.number().optional(),
                                        average_rating: zod.number().nullish(),
                                        rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                        has_user_reviewed: zod.boolean().optional(),
                                        review_config: zod.record(zod.string(), zod.unknown()).nullish(),
                                        review_questions: zod.array(zod.record(zod.string(), zod.unknown())).optional(),
                                        likes_count: zod.number().nullish().describe("Number of likes"),
                                        is_liked_by_current_user: zod
                                            .boolean()
                                            .optional()
                                            .describe("Whether current user has liked this product"),
                                        comments_count: zod.number().nullish().describe("Number of comments"),
                                    })
                                    .strict()
                                    .describe("Review post with enriched user, likes, comments, and reads data"),
                            )
                            .optional()
                            .describe("Product reviews with enriched data"),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const CreateItem401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const CreateItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const CreateItem409Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const CreateItem422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const CreateItem500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * @summary Get product detail by ID with reviews
 */
export const GetItemParams = zod
    .object({
        product_id: zod.number().describe("Product ID"),
    })
    .strict();

export const GetItemQueryParams = zod
    .object({
        user: zod.number().min(1).optional().describe("Filter returned reviews by user ID"),
        user_id: zod.number().min(1).optional().describe("Alias of `user` (filter returned reviews by user ID)"),
    })
    .strict();

export const getItem200ResponseDataItemOneOneProductStatusDefault = `draft`;
export const getItem200ResponseDataItemOneOneProductNameMax = 255;

export const getItem200ResponseDataItemOneOneProductUrlMax = 2048;

export const getItem200ResponseDataItemOneOnePriceUnitMax = 10;

export const getItem200ResponseDataItemOneOneParentCategoryNameMax = 100;

export const getItem200ResponseDataItemOneOneBrandNameMax = 100;

export const getItem200ResponseDataItemOneOneCategoryNameMax = 100;

export const getItem200ResponseDataItemOneOneUnitMax = 100;

export const getItem200ResponseDataItemOneOneKeywordMax = 500;

export const getItem200ResponseDataItemOneTwoReviewSummaryEnMax = 500;

export const getItem200ResponseDataItemOneTwoReviewSummaryJaMax = 500;

export const getItem200ResponseDataItemOneTwoRecommendRankMax = 15;

export const getItem200ResponseDataItemOneTwoManualScoreOffsetMin = 0;
export const getItem200ResponseDataItemOneTwoManualScoreOffsetMax = 100;

export const getItem200ResponseDataItemOneTwoReviewQuestionAveragesItemQuestionTextThMax = 200;

export const getItem200ResponseDataItemOneTwoReviewQuestionAveragesItemQuestionTextEnMax = 200;

export const getItem200ResponseDataItemOneTwoReviewQuestionAveragesItemQuestionTextJaMax = 200;

export const getItem200ResponseDataItemOneTwoCategoryCategoryNameMax = 100;

export const getItem200ResponseDataItemOneTwoCategoryCategoryIconMax = 40;

export const getItem200ResponseDataItemOneTwoCategoryParentCategoryNameMax = 100;

export const getItem200ResponseDataItemOneTwoBrandBrandIndexMax = 5;

export const getItem200ResponseDataItemOneTwoBrandBrandNameMax = 100;

export const getItem200ResponseDataItemOneTwoBrandCountryMax = 100;

export const getItem200ResponseDataItemOneTwoBrandWebsiteMax = 1024;

export const getItem200ResponseDataItemOneTwoReviewsItemPostTitleMax = 300;

export const getItem200ResponseDataItemOneTwoReviewsItemUserDisplayNameMax = 50;

export const getItem200ResponseDataItemOneTwoReviewsItemUserFirstNameMax = 100;

export const getItem200ResponseDataItemOneTwoReviewsItemUserLastNameMax = 100;

export const getItem200ResponseDataItemOneTwoReviewsItemUserNickNameMax = 50;

export const getItem200ResponseDataItemOneTwoReviewsItemUserPreferredPriceRangeMax = 50;

export const getItem200ResponseDataItemOneTwoReviewsItemUserSocialInstagramMax = 100;

export const getItem200ResponseDataItemOneTwoReviewsItemUserSocialFacebookMax = 100;

export const getItem200ResponseDataItemOneTwoReviewsItemUserSocialXMax = 100;

export const getItem200ResponseDataItemOneTwoReviewsItemUserSocialTiktokMax = 100;

export const getItem200ResponseDataItemOneTwoReviewsItemUserSocialYoutubeMax = 100;

export const getItem200ResponseDataItemOneTwoReviewsItemUserSocialWebsiteMax = 500;

export const getItem200ResponseDataItemOneTwoReviewsItemUserAvatarMax = 255;

export const getItem200ResponseDataItemOneTwoReviewsItemManualScoreOffsetMin = 0;
export const getItem200ResponseDataItemOneTwoReviewsItemManualScoreOffsetMax = 100;

export const getItem200ResponseDataReviewsItemPostTitleMax = 300;

export const getItem200ResponseDataReviewsItemUserDisplayNameMax = 50;

export const getItem200ResponseDataReviewsItemUserFirstNameMax = 100;

export const getItem200ResponseDataReviewsItemUserLastNameMax = 100;

export const getItem200ResponseDataReviewsItemUserNickNameMax = 50;

export const getItem200ResponseDataReviewsItemUserPreferredPriceRangeMax = 50;

export const getItem200ResponseDataReviewsItemUserSocialInstagramMax = 100;

export const getItem200ResponseDataReviewsItemUserSocialFacebookMax = 100;

export const getItem200ResponseDataReviewsItemUserSocialXMax = 100;

export const getItem200ResponseDataReviewsItemUserSocialTiktokMax = 100;

export const getItem200ResponseDataReviewsItemUserSocialYoutubeMax = 100;

export const getItem200ResponseDataReviewsItemUserSocialWebsiteMax = 500;

export const getItem200ResponseDataReviewsItemUserAvatarMax = 255;

export const getItem200ResponseDataReviewsItemManualScoreOffsetMin = 0;
export const getItem200ResponseDataReviewsItemManualScoreOffsetMax = 100;

export const GetItem200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .union([
                        zod
                            .object({
                                product_id: zod.number().optional().describe("Unique product identifier"),
                                product_status: zod
                                    .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
                                    .default(getItem200ResponseDataItemOneOneProductStatusDefault)
                                    .describe("Product publication status"),
                                product_name: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneOneProductNameMax)
                                    .optional()
                                    .describe("Product name (English only)"),
                                product_note: zod
                                    .string()
                                    .optional()
                                    .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                                created_by: zod.number().nullish().describe("User ID who created this product (audit)"),
                                updated_by: zod
                                    .number()
                                    .nullish()
                                    .describe("User ID who last updated this product (audit)"),
                                product_url: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneOneProductUrlMax)
                                    .optional()
                                    .describe("Product URL"),
                                general_description: zod.string().optional().describe("Product description"),
                                price: zod.number().nullish().describe("Product price"),
                                price_unit: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneOnePriceUnitMax)
                                    .optional()
                                    .describe("Price unit (e.g., THB, USD)"),
                                image: zod.string().optional().describe("Product image URL"),
                                category_id: zod.number().nullish().describe("Category ID (foreign key)"),
                                parent_category_id: zod
                                    .number()
                                    .nullish()
                                    .describe("Parent category ID (derived from category_id)"),
                                parent_category_name: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneOneParentCategoryNameMax)
                                    .optional()
                                    .describe("Parent category name (flattened for client convenience)"),
                                brand_id: zod.number().nullish().describe("Brand ID (foreign key)"),
                                brand_name: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneOneBrandNameMax)
                                    .optional()
                                    .describe("Brand name (flattened for client convenience)"),
                                category_name: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneOneCategoryNameMax)
                                    .optional()
                                    .describe("Category name (flattened for client convenience)"),
                                group_id: zod
                                    .union([
                                        zod.number().describe("Product group identifier"),
                                        zod.string().describe("Product group identifier"),
                                    ])
                                    .nullish(),
                                likes_count: zod.number().nullish().describe("Number of likes"),
                                comments_count: zod.number().nullish().describe("Number of comments"),
                                reads_count: zod.number().nullish().describe("Number of reads"),
                                unit: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneOneUnitMax)
                                    .optional()
                                    .describe("Product unit (e.g., piece, bottle, box)"),
                                keyword: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneOneKeywordMax)
                                    .optional()
                                    .describe("Search keyword(s)"),
                                how_to_use: zod.string().optional().describe("Usage instructions"),
                                ingredients: zod.string().optional().describe("Ingredients \/ raw materials"),
                                positive_points_th: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Positive review points (Thai)"),
                                negative_points_th: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Negative review points (Thai)"),
                                positive_points_en: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Positive review points (English)"),
                                negative_points_en: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Negative review points (English)"),
                                positive_points_ja: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Positive review points (Japanese)"),
                                negative_points_ja: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Negative review points (Japanese)"),
                                review_summary_th: zod.string().optional().describe("Thai review summary"),
                                review_summary_en: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneTwoReviewSummaryEnMax)
                                    .optional()
                                    .describe("English review summary"),
                                review_summary_ja: zod
                                    .string()
                                    .max(getItem200ResponseDataItemOneTwoReviewSummaryJaMax)
                                    .optional()
                                    .describe("Japanese review summary"),
                                created_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Creation timestamp"),
                                updated_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Last update timestamp"),
                                image_url: zod.string().optional().describe("Canonical absolute image URL"),
                                likes: zod.array(zod.object({}).passthrough()).optional(),
                                comments: zod.array(zod.object({}).passthrough()).optional(),
                                recommend_rank: zod
                                    .number()
                                    .min(1)
                                    .max(getItem200ResponseDataItemOneTwoRecommendRankMax)
                                    .nullish()
                                    .describe("Recommend rank for crown display (ISS:04-047)"),
                                monthly_rank: zod
                                    .number()
                                    .min(1)
                                    .nullish()
                                    .describe(
                                        "Monthly ranking rank (materialized; previous month based on real date) (ISS:04-048)",
                                    ),
                                manual_score_offset: zod
                                    .number()
                                    .min(getItem200ResponseDataItemOneTwoManualScoreOffsetMin)
                                    .max(getItem200ResponseDataItemOneTwoManualScoreOffsetMax)
                                    .nullish()
                                    .describe(
                                        "Manual score offset added to monthly metric value to stabilize ranking (ISS:05-014)",
                                    ),
                                review_count: zod
                                    .number()
                                    .nullish()
                                    .describe("Total number of reviews for this product"),
                                review_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Guest-facing review_count — 0 when a guest can't browse to this product (draft\/rejected\/dummy\/duplicated\/brand-placeholder status; equals review_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                                    ),
                                posts_count: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Total number of posts for this product, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                                    ),
                                posts_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Guest-facing posts_count — 0 when a guest can't browse to this product (same basis as review_count_guest; equals posts_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                                    ),
                                average_rating: zod
                                    .number()
                                    .nullish()
                                    .describe("Average rating from all reviews (1-5 scale)"),
                                likes_by_post: zod
                                    .record(zod.string(), zod.array(zod.object({}).passthrough()))
                                    .optional()
                                    .describe("Likes grouped by post ID for list\/detail convenience"),
                                comments_by_post: zod
                                    .record(zod.string(), zod.array(zod.object({}).passthrough()))
                                    .optional()
                                    .describe("Comments grouped by post ID for list\/detail convenience"),
                                review_question_averages: zod
                                    .array(
                                        zod
                                            .object({
                                                review_question_id: zod
                                                    .number()
                                                    .optional()
                                                    .describe("Review question ID"),
                                                average: zod
                                                    .number()
                                                    .nullish()
                                                    .describe("Average score for the review question"),
                                                count: zod
                                                    .number()
                                                    .optional()
                                                    .describe("Number of reviews included in the average"),
                                                data_type: zod
                                                    .enum(["rating", "text", "single_select", "multi_select"])
                                                    .optional()
                                                    .describe("Review question data type"),
                                                question_text_th: zod
                                                    .string()
                                                    .max(
                                                        getItem200ResponseDataItemOneTwoReviewQuestionAveragesItemQuestionTextThMax,
                                                    )
                                                    .optional()
                                                    .describe("Review question text in Thai"),
                                                question_text_en: zod
                                                    .string()
                                                    .max(
                                                        getItem200ResponseDataItemOneTwoReviewQuestionAveragesItemQuestionTextEnMax,
                                                    )
                                                    .optional()
                                                    .describe("Review question text in English"),
                                                question_text_ja: zod
                                                    .string()
                                                    .max(
                                                        getItem200ResponseDataItemOneTwoReviewQuestionAveragesItemQuestionTextJaMax,
                                                    )
                                                    .optional()
                                                    .describe("Review question text in Japanese"),
                                            })
                                            .strict(),
                                    )
                                    .optional()
                                    .describe("Average rating by review question for the product detail view"),
                                category: zod
                                    .object({
                                        category_id: zod.number().nullish().describe("Category ID"),
                                        category_name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemOneTwoCategoryCategoryNameMax)
                                            .optional()
                                            .describe("Category name"),
                                        category_icon: zod
                                            .string()
                                            .max(getItem200ResponseDataItemOneTwoCategoryCategoryIconMax)
                                            .optional()
                                            .describe(
                                                "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                            ),
                                        parent_category_id: zod.number().nullish().describe("Parent category ID"),
                                        parent_category_name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemOneTwoCategoryParentCategoryNameMax)
                                            .optional()
                                            .describe("Parent category name"),
                                        display_order: zod.number().optional().describe("Display order"),
                                    })
                                    .strict()
                                    .nullish()
                                    .describe("Category information"),
                                brand: zod
                                    .object({
                                        brand_id: zod.number().nullish().describe("Brand ID"),
                                        brand_index: zod
                                            .string()
                                            .max(getItem200ResponseDataItemOneTwoBrandBrandIndexMax)
                                            .optional()
                                            .describe("Brand index code"),
                                        brand_name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemOneTwoBrandBrandNameMax)
                                            .optional()
                                            .describe("Brand name"),
                                        image_url: zod.string().optional().describe("Brand logo\/icon URL"),
                                        brand_description_th: zod
                                            .string()
                                            .optional()
                                            .describe("Brand description in Thai"),
                                        brand_description_en: zod
                                            .string()
                                            .optional()
                                            .describe("Brand description in English"),
                                        brand_description_ja: zod
                                            .string()
                                            .optional()
                                            .describe("Brand description in Japanese"),
                                        country: zod
                                            .string()
                                            .max(getItem200ResponseDataItemOneTwoBrandCountryMax)
                                            .optional()
                                            .describe("Brand country of origin"),
                                        website: zod
                                            .string()
                                            .max(getItem200ResponseDataItemOneTwoBrandWebsiteMax)
                                            .optional()
                                            .describe("Brand official website"),
                                    })
                                    .strict()
                                    .nullish()
                                    .describe("Brand information"),
                                reviews: zod
                                    .array(
                                        zod
                                            .object({
                                                post_id: zod.number().optional().describe("Post ID"),
                                                board_id: zod
                                                    .enum([
                                                        "review",
                                                        "tiktoks",
                                                        "beauty_news",
                                                        "editorial_reviews",
                                                        "expert_reviews",
                                                        "activities",
                                                        "test_modal",
                                                        "test_modeless",
                                                        "guidance",
                                                    ])
                                                    .optional()
                                                    .describe("Board ID (should be 'review')"),
                                                post_product_id: zod
                                                    .union([
                                                        zod
                                                            .number()
                                                            .describe("Associated product ID on the post record"),
                                                        zod
                                                            .string()
                                                            .describe("Associated product ID on the post record"),
                                                    ])
                                                    .nullish(),
                                                user_id: zod
                                                    .number()
                                                    .optional()
                                                    .describe("User ID who created the review"),
                                                post_title: zod
                                                    .string()
                                                    .max(getItem200ResponseDataItemOneTwoReviewsItemPostTitleMax)
                                                    .optional()
                                                    .describe("Review title"),
                                                content: zod.string().optional().describe("Review content"),
                                                attached_images: zod
                                                    .array(zod.string())
                                                    .optional()
                                                    .describe("Attached image filenames"),
                                                attached_videos: zod
                                                    .array(zod.string())
                                                    .optional()
                                                    .describe("Attached video filenames"),
                                                content_images: zod
                                                    .array(zod.string())
                                                    .optional()
                                                    .describe("Images extracted from content"),
                                                created_at: zod
                                                    .string()
                                                    .datetime({ offset: true })
                                                    .optional()
                                                    .describe("Creation timestamp"),
                                                updated_at: zod
                                                    .string()
                                                    .datetime({ offset: true })
                                                    .optional()
                                                    .describe("Last update timestamp"),
                                                user: zod
                                                    .object({
                                                        user_id: zod.number().optional(),
                                                        username: zod.string().optional(),
                                                        display_name: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserDisplayNameMax,
                                                            )
                                                            .optional(),
                                                        first_name: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserFirstNameMax,
                                                            )
                                                            .optional(),
                                                        last_name: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserLastNameMax,
                                                            )
                                                            .optional(),
                                                        nick_name: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserNickNameMax,
                                                            )
                                                            .optional(),
                                                        date_of_birth: zod.string().date().nullish(),
                                                        gender: zod
                                                            .enum(["male", "female", "other", "prefer_not_to_say"])
                                                            .nullish(),
                                                        skin_type: zod
                                                            .enum([
                                                                "normal",
                                                                "oily",
                                                                "dry",
                                                                "combination",
                                                                "sensitive",
                                                                "dehydrated_oily",
                                                                "not_sure",
                                                            ])
                                                            .nullish(),
                                                        skin_concerns: zod.array(zod.string()).optional(),
                                                        skin_tone: zod
                                                            .enum([
                                                                "very_fair",
                                                                "fair",
                                                                "medium",
                                                                "tan",
                                                                "deep",
                                                                "not_sure",
                                                            ])
                                                            .nullish(),
                                                        hair_type: zod
                                                            .enum([
                                                                "straight_coarse",
                                                                "straight_soft",
                                                                "wavy_coarse",
                                                                "wavy_soft",
                                                                "normal_hair",
                                                                "not_sure",
                                                            ])
                                                            .nullish(),
                                                        hair_scalp_concerns: zod.array(zod.string()).optional(),
                                                        beauty_wellness_interests: zod.array(zod.string()).optional(),
                                                        lifestyle_environment: zod.array(zod.string()).optional(),
                                                        makeup_frequency: zod
                                                            .enum(["every_day", "occasionally", "rarely"])
                                                            .nullish(),
                                                        preferred_price_range: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserPreferredPriceRangeMax,
                                                            )
                                                            .optional(),
                                                        social_instagram: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserSocialInstagramMax,
                                                            )
                                                            .optional(),
                                                        social_facebook: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserSocialFacebookMax,
                                                            )
                                                            .optional(),
                                                        social_x: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserSocialXMax,
                                                            )
                                                            .optional(),
                                                        social_tiktok: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserSocialTiktokMax,
                                                            )
                                                            .optional(),
                                                        social_youtube: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserSocialYoutubeMax,
                                                            )
                                                            .optional(),
                                                        social_website: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserSocialWebsiteMax,
                                                            )
                                                            .optional(),
                                                        avatar: zod
                                                            .string()
                                                            .max(
                                                                getItem200ResponseDataItemOneTwoReviewsItemUserAvatarMax,
                                                            )
                                                            .optional(),
                                                        role: zod
                                                            .enum(["admin", "editor", "moderator", "expert", "user"])
                                                            .optional(),
                                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                                        recommend_rank: zod.number().nullish(),
                                                        posts_count: zod.number().nullish(),
                                                        review_count: zod.number().nullish(),
                                                        followers_count: zod.number().optional(),
                                                        followings_count: zod.number().optional(),
                                                    })
                                                    .strict()
                                                    .optional()
                                                    .describe("User information"),
                                                review_data: zod
                                                    .object({
                                                        review_answer_id: zod.number().optional(),
                                                        review_config_id: zod
                                                            .union([zod.number(), zod.string()])
                                                            .optional(),
                                                        post_id: zod.number().optional(),
                                                        answers: zod.array(zod.object({}).passthrough()).optional(),
                                                    })
                                                    .strict()
                                                    .optional()
                                                    .describe("Review answer data from ReviewAnswers"),
                                                delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                                post_status: zod
                                                    .enum(["draft", "editing", "released", "rejected"])
                                                    .optional(),
                                                reads_count: zod.number().nullish(),
                                                sns_links: zod.array(zod.string().url()).optional(),
                                                recommend_rank: zod.number().nullish(),
                                                monthly_rank: zod.number().nullish(),
                                                manual_score_offset: zod
                                                    .number()
                                                    .min(
                                                        getItem200ResponseDataItemOneTwoReviewsItemManualScoreOffsetMin,
                                                    )
                                                    .max(
                                                        getItem200ResponseDataItemOneTwoReviewsItemManualScoreOffsetMax,
                                                    )
                                                    .nullish(),
                                                sns_shares: zod.array(zod.enum(["instagram", "tiktok"])).optional(),
                                                board: zod.record(zod.string(), zod.unknown()).optional(),
                                                likes: zod.array(zod.object({}).passthrough()).optional(),
                                                reads: zod.array(zod.object({}).passthrough()).optional(),
                                                comments: zod.array(zod.object({}).passthrough()).optional(),
                                                review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                                reviews_count: zod.number().optional(),
                                                average_rating: zod.number().nullish(),
                                                rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                                has_user_reviewed: zod.boolean().optional(),
                                                review_config: zod.record(zod.string(), zod.unknown()).nullish(),
                                                review_questions: zod
                                                    .array(zod.record(zod.string(), zod.unknown()))
                                                    .optional(),
                                                likes_count: zod.number().nullish().describe("Number of likes"),
                                                is_liked_by_current_user: zod
                                                    .boolean()
                                                    .optional()
                                                    .describe("Whether current user has liked this product"),
                                                comments_count: zod.number().nullish().describe("Number of comments"),
                                            })
                                            .strict()
                                            .describe(
                                                "Review post with enriched user, likes, comments, and reads data",
                                            ),
                                    )
                                    .optional()
                                    .describe("Product reviews with enriched data"),
                            })
                            .strict(),
                        zod.null(),
                    ])
                    .optional(),
                reviews: zod
                    .array(
                        zod
                            .object({
                                post_id: zod.number().optional().describe("Post ID"),
                                board_id: zod
                                    .enum([
                                        "review",
                                        "tiktoks",
                                        "beauty_news",
                                        "editorial_reviews",
                                        "expert_reviews",
                                        "activities",
                                        "test_modal",
                                        "test_modeless",
                                        "guidance",
                                    ])
                                    .optional()
                                    .describe("Board ID (should be 'review')"),
                                post_product_id: zod
                                    .union([
                                        zod.number().describe("Associated product ID on the post record"),
                                        zod.string().describe("Associated product ID on the post record"),
                                    ])
                                    .nullish(),
                                user_id: zod.number().optional().describe("User ID who created the review"),
                                post_title: zod
                                    .string()
                                    .max(getItem200ResponseDataReviewsItemPostTitleMax)
                                    .optional()
                                    .describe("Review title"),
                                content: zod.string().optional().describe("Review content"),
                                attached_images: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Attached image filenames"),
                                attached_videos: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Attached video filenames"),
                                content_images: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Images extracted from content"),
                                created_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Creation timestamp"),
                                updated_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Last update timestamp"),
                                user: zod
                                    .object({
                                        user_id: zod.number().optional(),
                                        username: zod.string().optional(),
                                        display_name: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserDisplayNameMax)
                                            .optional(),
                                        first_name: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserFirstNameMax)
                                            .optional(),
                                        last_name: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserLastNameMax)
                                            .optional(),
                                        nick_name: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserNickNameMax)
                                            .optional(),
                                        date_of_birth: zod.string().date().nullish(),
                                        gender: zod.enum(["male", "female", "other", "prefer_not_to_say"]).nullish(),
                                        skin_type: zod
                                            .enum([
                                                "normal",
                                                "oily",
                                                "dry",
                                                "combination",
                                                "sensitive",
                                                "dehydrated_oily",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        skin_concerns: zod.array(zod.string()).optional(),
                                        skin_tone: zod
                                            .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                            .nullish(),
                                        hair_type: zod
                                            .enum([
                                                "straight_coarse",
                                                "straight_soft",
                                                "wavy_coarse",
                                                "wavy_soft",
                                                "normal_hair",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        hair_scalp_concerns: zod.array(zod.string()).optional(),
                                        beauty_wellness_interests: zod.array(zod.string()).optional(),
                                        lifestyle_environment: zod.array(zod.string()).optional(),
                                        makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                                        preferred_price_range: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserPreferredPriceRangeMax)
                                            .optional(),
                                        social_instagram: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserSocialInstagramMax)
                                            .optional(),
                                        social_facebook: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserSocialFacebookMax)
                                            .optional(),
                                        social_x: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserSocialXMax)
                                            .optional(),
                                        social_tiktok: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserSocialTiktokMax)
                                            .optional(),
                                        social_youtube: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserSocialYoutubeMax)
                                            .optional(),
                                        social_website: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserSocialWebsiteMax)
                                            .optional(),
                                        avatar: zod
                                            .string()
                                            .max(getItem200ResponseDataReviewsItemUserAvatarMax)
                                            .optional(),
                                        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        posts_count: zod.number().nullish(),
                                        review_count: zod.number().nullish(),
                                        followers_count: zod.number().optional(),
                                        followings_count: zod.number().optional(),
                                    })
                                    .strict()
                                    .optional()
                                    .describe("User information"),
                                review_data: zod
                                    .object({
                                        review_answer_id: zod.number().optional(),
                                        review_config_id: zod.union([zod.number(), zod.string()]).optional(),
                                        post_id: zod.number().optional(),
                                        answers: zod.array(zod.object({}).passthrough()).optional(),
                                    })
                                    .strict()
                                    .optional()
                                    .describe("Review answer data from ReviewAnswers"),
                                delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                reads_count: zod.number().nullish(),
                                sns_links: zod.array(zod.string().url()).optional(),
                                recommend_rank: zod.number().nullish(),
                                monthly_rank: zod.number().nullish(),
                                manual_score_offset: zod
                                    .number()
                                    .min(getItem200ResponseDataReviewsItemManualScoreOffsetMin)
                                    .max(getItem200ResponseDataReviewsItemManualScoreOffsetMax)
                                    .nullish(),
                                sns_shares: zod.array(zod.enum(["instagram", "tiktok"])).optional(),
                                board: zod.record(zod.string(), zod.unknown()).optional(),
                                likes: zod.array(zod.object({}).passthrough()).optional(),
                                reads: zod.array(zod.object({}).passthrough()).optional(),
                                comments: zod.array(zod.object({}).passthrough()).optional(),
                                review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                reviews_count: zod.number().optional(),
                                average_rating: zod.number().nullish(),
                                rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                has_user_reviewed: zod.boolean().optional(),
                                review_config: zod.record(zod.string(), zod.unknown()).nullish(),
                                review_questions: zod.array(zod.record(zod.string(), zod.unknown())).optional(),
                                likes_count: zod.number().nullish().describe("Number of likes"),
                                is_liked_by_current_user: zod
                                    .boolean()
                                    .optional()
                                    .describe("Whether current user has liked this product"),
                                comments_count: zod.number().nullish().describe("Number of comments"),
                            })
                            .strict()
                            .describe("Review post with enriched user, likes, comments, and reads data"),
                    )
                    .optional()
                    .describe("Product reviews with enriched data"),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetItem400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(403), zod.literal(404)]).describe("HTTP status code"),
    })
    .strict();

export const GetItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(403), zod.literal(404)]).describe("HTTP status code"),
    })
    .strict();

export const GetItem404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(403), zod.literal(404)]).describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Update product (admin/editor only)
 */
export const UpdateItemParams = zod
    .object({
        product_id: zod.number().describe("Product ID"),
    })
    .strict();

export const updateItemBodyProductStatusDefault = `draft`;
export const updateItemBodyProductNameMax = 255;

export const updateItemBodyProductUrlMax = 2048;

export const updateItemBodyImageDefault = `media/products/no_image.jpg`;
export const updateItemBodyImageMax = 2048;

export const updateItemBodyPriceUnitDefault = `THB`;
export const updateItemBodyPriceUnitMax = 10;

export const updateItemBodyUnitMax = 100;

export const updateItemBodyKeywordMax = 500;

export const updateItemBodyReviewSummaryEnMax = 500;

export const updateItemBodyReviewSummaryJaMax = 500;

export const updateItemBodyManualScoreOffsetMin = 0;
export const updateItemBodyManualScoreOffsetMax = 100;

export const UpdateItemBody = zod
    .object({
        product_status: zod
            .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
            .default(updateItemBodyProductStatusDefault)
            .describe("Product status"),
        product_name: zod.string().max(updateItemBodyProductNameMax).optional(),
        product_url: zod.string().max(updateItemBodyProductUrlMax).optional(),
        general_description: zod.string().optional(),
        product_note: zod
            .string()
            .optional()
            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
        image: zod.string().max(updateItemBodyImageMax).default(updateItemBodyImageDefault),
        price: zod.number().nullish(),
        price_unit: zod.string().max(updateItemBodyPriceUnitMax).default(updateItemBodyPriceUnitDefault),
        category_id: zod.number().nullish(),
        brand_id: zod.number().nullish(),
        group_id: zod.union([zod.number(), zod.string()]).nullish(),
        unit: zod.string().max(updateItemBodyUnitMax).optional(),
        keyword: zod.string().max(updateItemBodyKeywordMax).optional(),
        how_to_use: zod.string().optional(),
        ingredients: zod.string().optional(),
        positive_points_th: zod.array(zod.string()).optional(),
        negative_points_th: zod.array(zod.string()).optional(),
        positive_points_en: zod.array(zod.string()).optional(),
        negative_points_en: zod.array(zod.string()).optional(),
        positive_points_ja: zod.array(zod.string()).optional(),
        negative_points_ja: zod.array(zod.string()).optional(),
        review_summary_th: zod.string().optional(),
        review_summary_en: zod.string().max(updateItemBodyReviewSummaryEnMax).optional(),
        review_summary_ja: zod.string().max(updateItemBodyReviewSummaryJaMax).optional(),
        manual_score_offset: zod
            .number()
            .min(updateItemBodyManualScoreOffsetMin)
            .max(updateItemBodyManualScoreOffsetMax)
            .nullish(),
    })
    .strict();

export const updateItem200ResponseDataItemOneProductStatusDefault = `draft`;
export const updateItem200ResponseDataItemOneProductNameMax = 255;

export const updateItem200ResponseDataItemOneProductUrlMax = 2048;

export const updateItem200ResponseDataItemOnePriceUnitMax = 10;

export const updateItem200ResponseDataItemOneParentCategoryNameMax = 100;

export const updateItem200ResponseDataItemOneBrandNameMax = 100;

export const updateItem200ResponseDataItemOneCategoryNameMax = 100;

export const updateItem200ResponseDataItemOneUnitMax = 100;

export const updateItem200ResponseDataItemOneKeywordMax = 500;

export const updateItem200ResponseDataItemTwoReviewSummaryEnMax = 500;

export const updateItem200ResponseDataItemTwoReviewSummaryJaMax = 500;

export const updateItem200ResponseDataItemTwoRecommendRankMax = 15;

export const updateItem200ResponseDataItemTwoManualScoreOffsetMin = 0;
export const updateItem200ResponseDataItemTwoManualScoreOffsetMax = 100;

export const updateItem200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextThMax = 200;

export const updateItem200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextEnMax = 200;

export const updateItem200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextJaMax = 200;

export const updateItem200ResponseDataItemTwoCategoryCategoryNameMax = 100;

export const updateItem200ResponseDataItemTwoCategoryCategoryIconMax = 40;

export const updateItem200ResponseDataItemTwoCategoryParentCategoryNameMax = 100;

export const updateItem200ResponseDataItemTwoBrandBrandIndexMax = 5;

export const updateItem200ResponseDataItemTwoBrandBrandNameMax = 100;

export const updateItem200ResponseDataItemTwoBrandCountryMax = 100;

export const updateItem200ResponseDataItemTwoBrandWebsiteMax = 1024;

export const updateItem200ResponseDataItemTwoReviewsItemPostTitleMax = 300;

export const updateItem200ResponseDataItemTwoReviewsItemUserDisplayNameMax = 50;

export const updateItem200ResponseDataItemTwoReviewsItemUserFirstNameMax = 100;

export const updateItem200ResponseDataItemTwoReviewsItemUserLastNameMax = 100;

export const updateItem200ResponseDataItemTwoReviewsItemUserNickNameMax = 50;

export const updateItem200ResponseDataItemTwoReviewsItemUserPreferredPriceRangeMax = 50;

export const updateItem200ResponseDataItemTwoReviewsItemUserSocialInstagramMax = 100;

export const updateItem200ResponseDataItemTwoReviewsItemUserSocialFacebookMax = 100;

export const updateItem200ResponseDataItemTwoReviewsItemUserSocialXMax = 100;

export const updateItem200ResponseDataItemTwoReviewsItemUserSocialTiktokMax = 100;

export const updateItem200ResponseDataItemTwoReviewsItemUserSocialYoutubeMax = 100;

export const updateItem200ResponseDataItemTwoReviewsItemUserSocialWebsiteMax = 500;

export const updateItem200ResponseDataItemTwoReviewsItemUserAvatarMax = 255;

export const updateItem200ResponseDataItemTwoReviewsItemManualScoreOffsetMin = 0;
export const updateItem200ResponseDataItemTwoReviewsItemManualScoreOffsetMax = 100;

export const UpdateItem200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        product_id: zod.number().optional().describe("Unique product identifier"),
                        product_status: zod
                            .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
                            .default(updateItem200ResponseDataItemOneProductStatusDefault)
                            .describe("Product publication status"),
                        product_name: zod
                            .string()
                            .max(updateItem200ResponseDataItemOneProductNameMax)
                            .optional()
                            .describe("Product name (English only)"),
                        product_note: zod
                            .string()
                            .optional()
                            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                        created_by: zod.number().nullish().describe("User ID who created this product (audit)"),
                        updated_by: zod.number().nullish().describe("User ID who last updated this product (audit)"),
                        product_url: zod
                            .string()
                            .max(updateItem200ResponseDataItemOneProductUrlMax)
                            .optional()
                            .describe("Product URL"),
                        general_description: zod.string().optional().describe("Product description"),
                        price: zod.number().nullish().describe("Product price"),
                        price_unit: zod
                            .string()
                            .max(updateItem200ResponseDataItemOnePriceUnitMax)
                            .optional()
                            .describe("Price unit (e.g., THB, USD)"),
                        image: zod.string().optional().describe("Product image URL"),
                        category_id: zod.number().nullish().describe("Category ID (foreign key)"),
                        parent_category_id: zod
                            .number()
                            .nullish()
                            .describe("Parent category ID (derived from category_id)"),
                        parent_category_name: zod
                            .string()
                            .max(updateItem200ResponseDataItemOneParentCategoryNameMax)
                            .optional()
                            .describe("Parent category name (flattened for client convenience)"),
                        brand_id: zod.number().nullish().describe("Brand ID (foreign key)"),
                        brand_name: zod
                            .string()
                            .max(updateItem200ResponseDataItemOneBrandNameMax)
                            .optional()
                            .describe("Brand name (flattened for client convenience)"),
                        category_name: zod
                            .string()
                            .max(updateItem200ResponseDataItemOneCategoryNameMax)
                            .optional()
                            .describe("Category name (flattened for client convenience)"),
                        group_id: zod
                            .union([
                                zod.number().describe("Product group identifier"),
                                zod.string().describe("Product group identifier"),
                            ])
                            .nullish(),
                        likes_count: zod.number().nullish().describe("Number of likes"),
                        comments_count: zod.number().nullish().describe("Number of comments"),
                        reads_count: zod.number().nullish().describe("Number of reads"),
                        unit: zod
                            .string()
                            .max(updateItem200ResponseDataItemOneUnitMax)
                            .optional()
                            .describe("Product unit (e.g., piece, bottle, box)"),
                        keyword: zod
                            .string()
                            .max(updateItem200ResponseDataItemOneKeywordMax)
                            .optional()
                            .describe("Search keyword(s)"),
                        how_to_use: zod.string().optional().describe("Usage instructions"),
                        ingredients: zod.string().optional().describe("Ingredients \/ raw materials"),
                        positive_points_th: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (Thai)"),
                        negative_points_th: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (Thai)"),
                        positive_points_en: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (English)"),
                        negative_points_en: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (English)"),
                        positive_points_ja: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (Japanese)"),
                        negative_points_ja: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (Japanese)"),
                        review_summary_th: zod.string().optional().describe("Thai review summary"),
                        review_summary_en: zod
                            .string()
                            .max(updateItem200ResponseDataItemTwoReviewSummaryEnMax)
                            .optional()
                            .describe("English review summary"),
                        review_summary_ja: zod
                            .string()
                            .max(updateItem200ResponseDataItemTwoReviewSummaryJaMax)
                            .optional()
                            .describe("Japanese review summary"),
                        created_at: zod.string().datetime({ offset: true }).optional().describe("Creation timestamp"),
                        updated_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Last update timestamp"),
                        image_url: zod.string().optional().describe("Canonical absolute image URL"),
                        likes: zod.array(zod.object({}).passthrough()).optional(),
                        comments: zod.array(zod.object({}).passthrough()).optional(),
                        recommend_rank: zod
                            .number()
                            .min(1)
                            .max(updateItem200ResponseDataItemTwoRecommendRankMax)
                            .nullish()
                            .describe("Recommend rank for crown display (ISS:04-047)"),
                        monthly_rank: zod
                            .number()
                            .min(1)
                            .nullish()
                            .describe(
                                "Monthly ranking rank (materialized; previous month based on real date) (ISS:04-048)",
                            ),
                        manual_score_offset: zod
                            .number()
                            .min(updateItem200ResponseDataItemTwoManualScoreOffsetMin)
                            .max(updateItem200ResponseDataItemTwoManualScoreOffsetMax)
                            .nullish()
                            .describe(
                                "Manual score offset added to monthly metric value to stabilize ranking (ISS:05-014)",
                            ),
                        review_count: zod.number().nullish().describe("Total number of reviews for this product"),
                        review_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing review_count — 0 when a guest can't browse to this product (draft\/rejected\/dummy\/duplicated\/brand-placeholder status; equals review_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        posts_count: zod
                            .number()
                            .nullish()
                            .describe(
                                "Total number of posts for this product, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                            ),
                        posts_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing posts_count — 0 when a guest can't browse to this product (same basis as review_count_guest; equals posts_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        average_rating: zod.number().nullish().describe("Average rating from all reviews (1-5 scale)"),
                        likes_by_post: zod
                            .record(zod.string(), zod.array(zod.object({}).passthrough()))
                            .optional()
                            .describe("Likes grouped by post ID for list\/detail convenience"),
                        comments_by_post: zod
                            .record(zod.string(), zod.array(zod.object({}).passthrough()))
                            .optional()
                            .describe("Comments grouped by post ID for list\/detail convenience"),
                        review_question_averages: zod
                            .array(
                                zod
                                    .object({
                                        review_question_id: zod.number().optional().describe("Review question ID"),
                                        average: zod
                                            .number()
                                            .nullish()
                                            .describe("Average score for the review question"),
                                        count: zod
                                            .number()
                                            .optional()
                                            .describe("Number of reviews included in the average"),
                                        data_type: zod
                                            .enum(["rating", "text", "single_select", "multi_select"])
                                            .optional()
                                            .describe("Review question data type"),
                                        question_text_th: zod
                                            .string()
                                            .max(
                                                updateItem200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextThMax,
                                            )
                                            .optional()
                                            .describe("Review question text in Thai"),
                                        question_text_en: zod
                                            .string()
                                            .max(
                                                updateItem200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextEnMax,
                                            )
                                            .optional()
                                            .describe("Review question text in English"),
                                        question_text_ja: zod
                                            .string()
                                            .max(
                                                updateItem200ResponseDataItemTwoReviewQuestionAveragesItemQuestionTextJaMax,
                                            )
                                            .optional()
                                            .describe("Review question text in Japanese"),
                                    })
                                    .strict(),
                            )
                            .optional()
                            .describe("Average rating by review question for the product detail view"),
                        category: zod
                            .object({
                                category_id: zod.number().nullish().describe("Category ID"),
                                category_name: zod
                                    .string()
                                    .max(updateItem200ResponseDataItemTwoCategoryCategoryNameMax)
                                    .optional()
                                    .describe("Category name"),
                                category_icon: zod
                                    .string()
                                    .max(updateItem200ResponseDataItemTwoCategoryCategoryIconMax)
                                    .optional()
                                    .describe(
                                        "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                    ),
                                parent_category_id: zod.number().nullish().describe("Parent category ID"),
                                parent_category_name: zod
                                    .string()
                                    .max(updateItem200ResponseDataItemTwoCategoryParentCategoryNameMax)
                                    .optional()
                                    .describe("Parent category name"),
                                display_order: zod.number().optional().describe("Display order"),
                            })
                            .strict()
                            .nullish()
                            .describe("Category information"),
                        brand: zod
                            .object({
                                brand_id: zod.number().nullish().describe("Brand ID"),
                                brand_index: zod
                                    .string()
                                    .max(updateItem200ResponseDataItemTwoBrandBrandIndexMax)
                                    .optional()
                                    .describe("Brand index code"),
                                brand_name: zod
                                    .string()
                                    .max(updateItem200ResponseDataItemTwoBrandBrandNameMax)
                                    .optional()
                                    .describe("Brand name"),
                                image_url: zod.string().optional().describe("Brand logo\/icon URL"),
                                brand_description_th: zod.string().optional().describe("Brand description in Thai"),
                                brand_description_en: zod.string().optional().describe("Brand description in English"),
                                brand_description_ja: zod.string().optional().describe("Brand description in Japanese"),
                                country: zod
                                    .string()
                                    .max(updateItem200ResponseDataItemTwoBrandCountryMax)
                                    .optional()
                                    .describe("Brand country of origin"),
                                website: zod
                                    .string()
                                    .max(updateItem200ResponseDataItemTwoBrandWebsiteMax)
                                    .optional()
                                    .describe("Brand official website"),
                            })
                            .strict()
                            .nullish()
                            .describe("Brand information"),
                        reviews: zod
                            .array(
                                zod
                                    .object({
                                        post_id: zod.number().optional().describe("Post ID"),
                                        board_id: zod
                                            .enum([
                                                "review",
                                                "tiktoks",
                                                "beauty_news",
                                                "editorial_reviews",
                                                "expert_reviews",
                                                "activities",
                                                "test_modal",
                                                "test_modeless",
                                                "guidance",
                                            ])
                                            .optional()
                                            .describe("Board ID (should be 'review')"),
                                        post_product_id: zod
                                            .union([
                                                zod.number().describe("Associated product ID on the post record"),
                                                zod.string().describe("Associated product ID on the post record"),
                                            ])
                                            .nullish(),
                                        user_id: zod.number().optional().describe("User ID who created the review"),
                                        post_title: zod
                                            .string()
                                            .max(updateItem200ResponseDataItemTwoReviewsItemPostTitleMax)
                                            .optional()
                                            .describe("Review title"),
                                        content: zod.string().optional().describe("Review content"),
                                        attached_images: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Attached image filenames"),
                                        attached_videos: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Attached video filenames"),
                                        content_images: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Images extracted from content"),
                                        created_at: zod
                                            .string()
                                            .datetime({ offset: true })
                                            .optional()
                                            .describe("Creation timestamp"),
                                        updated_at: zod
                                            .string()
                                            .datetime({ offset: true })
                                            .optional()
                                            .describe("Last update timestamp"),
                                        user: zod
                                            .object({
                                                user_id: zod.number().optional(),
                                                username: zod.string().optional(),
                                                display_name: zod
                                                    .string()
                                                    .max(updateItem200ResponseDataItemTwoReviewsItemUserDisplayNameMax)
                                                    .optional(),
                                                first_name: zod
                                                    .string()
                                                    .max(updateItem200ResponseDataItemTwoReviewsItemUserFirstNameMax)
                                                    .optional(),
                                                last_name: zod
                                                    .string()
                                                    .max(updateItem200ResponseDataItemTwoReviewsItemUserLastNameMax)
                                                    .optional(),
                                                nick_name: zod
                                                    .string()
                                                    .max(updateItem200ResponseDataItemTwoReviewsItemUserNickNameMax)
                                                    .optional(),
                                                date_of_birth: zod.string().date().nullish(),
                                                gender: zod
                                                    .enum(["male", "female", "other", "prefer_not_to_say"])
                                                    .nullish(),
                                                skin_type: zod
                                                    .enum([
                                                        "normal",
                                                        "oily",
                                                        "dry",
                                                        "combination",
                                                        "sensitive",
                                                        "dehydrated_oily",
                                                        "not_sure",
                                                    ])
                                                    .nullish(),
                                                skin_concerns: zod.array(zod.string()).optional(),
                                                skin_tone: zod
                                                    .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                                    .nullish(),
                                                hair_type: zod
                                                    .enum([
                                                        "straight_coarse",
                                                        "straight_soft",
                                                        "wavy_coarse",
                                                        "wavy_soft",
                                                        "normal_hair",
                                                        "not_sure",
                                                    ])
                                                    .nullish(),
                                                hair_scalp_concerns: zod.array(zod.string()).optional(),
                                                beauty_wellness_interests: zod.array(zod.string()).optional(),
                                                lifestyle_environment: zod.array(zod.string()).optional(),
                                                makeup_frequency: zod
                                                    .enum(["every_day", "occasionally", "rarely"])
                                                    .nullish(),
                                                preferred_price_range: zod
                                                    .string()
                                                    .max(
                                                        updateItem200ResponseDataItemTwoReviewsItemUserPreferredPriceRangeMax,
                                                    )
                                                    .optional(),
                                                social_instagram: zod
                                                    .string()
                                                    .max(
                                                        updateItem200ResponseDataItemTwoReviewsItemUserSocialInstagramMax,
                                                    )
                                                    .optional(),
                                                social_facebook: zod
                                                    .string()
                                                    .max(
                                                        updateItem200ResponseDataItemTwoReviewsItemUserSocialFacebookMax,
                                                    )
                                                    .optional(),
                                                social_x: zod
                                                    .string()
                                                    .max(updateItem200ResponseDataItemTwoReviewsItemUserSocialXMax)
                                                    .optional(),
                                                social_tiktok: zod
                                                    .string()
                                                    .max(updateItem200ResponseDataItemTwoReviewsItemUserSocialTiktokMax)
                                                    .optional(),
                                                social_youtube: zod
                                                    .string()
                                                    .max(
                                                        updateItem200ResponseDataItemTwoReviewsItemUserSocialYoutubeMax,
                                                    )
                                                    .optional(),
                                                social_website: zod
                                                    .string()
                                                    .max(
                                                        updateItem200ResponseDataItemTwoReviewsItemUserSocialWebsiteMax,
                                                    )
                                                    .optional(),
                                                avatar: zod
                                                    .string()
                                                    .max(updateItem200ResponseDataItemTwoReviewsItemUserAvatarMax)
                                                    .optional(),
                                                role: zod
                                                    .enum(["admin", "editor", "moderator", "expert", "user"])
                                                    .optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                recommend_rank: zod.number().nullish(),
                                                posts_count: zod.number().nullish(),
                                                review_count: zod.number().nullish(),
                                                followers_count: zod.number().optional(),
                                                followings_count: zod.number().optional(),
                                            })
                                            .strict()
                                            .optional()
                                            .describe("User information"),
                                        review_data: zod
                                            .object({
                                                review_answer_id: zod.number().optional(),
                                                review_config_id: zod.union([zod.number(), zod.string()]).optional(),
                                                post_id: zod.number().optional(),
                                                answers: zod.array(zod.object({}).passthrough()).optional(),
                                            })
                                            .strict()
                                            .optional()
                                            .describe("Review answer data from ReviewAnswers"),
                                        delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                        reads_count: zod.number().nullish(),
                                        sns_links: zod.array(zod.string().url()).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        monthly_rank: zod.number().nullish(),
                                        manual_score_offset: zod
                                            .number()
                                            .min(updateItem200ResponseDataItemTwoReviewsItemManualScoreOffsetMin)
                                            .max(updateItem200ResponseDataItemTwoReviewsItemManualScoreOffsetMax)
                                            .nullish(),
                                        sns_shares: zod.array(zod.enum(["instagram", "tiktok"])).optional(),
                                        board: zod.record(zod.string(), zod.unknown()).optional(),
                                        likes: zod.array(zod.object({}).passthrough()).optional(),
                                        reads: zod.array(zod.object({}).passthrough()).optional(),
                                        comments: zod.array(zod.object({}).passthrough()).optional(),
                                        review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        reviews_count: zod.number().optional(),
                                        average_rating: zod.number().nullish(),
                                        rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                        has_user_reviewed: zod.boolean().optional(),
                                        review_config: zod.record(zod.string(), zod.unknown()).nullish(),
                                        review_questions: zod.array(zod.record(zod.string(), zod.unknown())).optional(),
                                        likes_count: zod.number().nullish().describe("Number of likes"),
                                        is_liked_by_current_user: zod
                                            .boolean()
                                            .optional()
                                            .describe("Whether current user has liked this product"),
                                        comments_count: zod.number().nullish().describe("Number of comments"),
                                    })
                                    .strict()
                                    .describe("Review post with enriched user, likes, comments, and reads data"),
                            )
                            .optional()
                            .describe("Product reviews with enriched data"),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UpdateItem401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpdateItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpdateItem404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpdateItem409Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpdateItem422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpdateItem500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * @summary Delete product (admin/editor only)
 */
export const DeleteItemParams = zod
    .object({
        product_id: zod.number().describe("Product ID"),
    })
    .strict();

export const DeleteItem200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                deleted: zod.boolean().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const DeleteItem401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const DeleteItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const DeleteItem404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const DeleteItem500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * Auto-detects merge-target candidates by parsing product_id references out of this product's product_note (written by master:mark-duplicates — see StatusNoteHelper::appendDuplicateNote()). Returns the source product itself plus each candidate's full record, for the merge tool modal's two-column comparison.
 * @summary Merge-target candidates for a duplicated product (admin/editor only)
 */
export const GetProductMergeCandidatesParams = zod
    .object({
        product_id: zod.number(),
    })
    .strict();

export const GetProductMergeCandidatesQueryParams = zod
    .object({
        target_id: zod
            .number()
            .optional()
            .describe(
                "Admin-typed product_id to include as a merge-target candidate even if it wasn't auto-detected from product_note.",
            ),
    })
    .strict();

export const getProductMergeCandidates200ResponseDataSourceOneProductStatusDefault = `draft`;
export const getProductMergeCandidates200ResponseDataSourceOneProductNameMax = 255;

export const getProductMergeCandidates200ResponseDataSourceOneProductUrlMax = 2048;

export const getProductMergeCandidates200ResponseDataSourceOnePriceUnitMax = 10;

export const getProductMergeCandidates200ResponseDataSourceOneParentCategoryNameMax = 100;

export const getProductMergeCandidates200ResponseDataSourceOneBrandNameMax = 100;

export const getProductMergeCandidates200ResponseDataSourceOneCategoryNameMax = 100;

export const getProductMergeCandidates200ResponseDataSourceOneUnitMax = 100;

export const getProductMergeCandidates200ResponseDataSourceOneKeywordMax = 500;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewSummaryEnMax = 500;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewSummaryJaMax = 500;

export const getProductMergeCandidates200ResponseDataSourceTwoRecommendRankMax = 15;

export const getProductMergeCandidates200ResponseDataSourceTwoManualScoreOffsetMin = 0;
export const getProductMergeCandidates200ResponseDataSourceTwoManualScoreOffsetMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewQuestionAveragesItemQuestionTextThMax = 200;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewQuestionAveragesItemQuestionTextEnMax = 200;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewQuestionAveragesItemQuestionTextJaMax = 200;

export const getProductMergeCandidates200ResponseDataSourceTwoCategoryCategoryNameMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoCategoryCategoryIconMax = 40;

export const getProductMergeCandidates200ResponseDataSourceTwoCategoryParentCategoryNameMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoBrandBrandIndexMax = 5;

export const getProductMergeCandidates200ResponseDataSourceTwoBrandBrandNameMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoBrandCountryMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoBrandWebsiteMax = 1024;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemPostTitleMax = 300;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserDisplayNameMax = 50;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserFirstNameMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserLastNameMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserNickNameMax = 50;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserPreferredPriceRangeMax = 50;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialInstagramMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialFacebookMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialXMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialTiktokMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialYoutubeMax = 100;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialWebsiteMax = 500;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserAvatarMax = 255;

export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemManualScoreOffsetMin = 0;
export const getProductMergeCandidates200ResponseDataSourceTwoReviewsItemManualScoreOffsetMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemOneProductStatusDefault = `draft`;
export const getProductMergeCandidates200ResponseDataCandidatesItemOneProductNameMax = 255;

export const getProductMergeCandidates200ResponseDataCandidatesItemOneProductUrlMax = 2048;

export const getProductMergeCandidates200ResponseDataCandidatesItemOnePriceUnitMax = 10;

export const getProductMergeCandidates200ResponseDataCandidatesItemOneParentCategoryNameMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemOneBrandNameMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemOneCategoryNameMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemOneUnitMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemOneKeywordMax = 500;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewSummaryEnMax = 500;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewSummaryJaMax = 500;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoRecommendRankMax = 15;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoManualScoreOffsetMin = 0;
export const getProductMergeCandidates200ResponseDataCandidatesItemTwoManualScoreOffsetMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewQuestionAveragesItemQuestionTextThMax = 200;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewQuestionAveragesItemQuestionTextEnMax = 200;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewQuestionAveragesItemQuestionTextJaMax = 200;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoCategoryCategoryNameMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoCategoryCategoryIconMax = 40;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoCategoryParentCategoryNameMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoBrandBrandIndexMax = 5;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoBrandBrandNameMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoBrandCountryMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoBrandWebsiteMax = 1024;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemPostTitleMax = 300;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserDisplayNameMax = 50;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserFirstNameMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserLastNameMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserNickNameMax = 50;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserPreferredPriceRangeMax = 50;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialInstagramMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialFacebookMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialXMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialTiktokMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialYoutubeMax = 100;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialWebsiteMax = 500;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserAvatarMax = 255;

export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemManualScoreOffsetMin = 0;
export const getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemManualScoreOffsetMax = 100;

export const GetProductMergeCandidates200Response = zod
    .object({
        data: zod
            .object({
                source: zod
                    .object({
                        product_id: zod.number().optional().describe("Unique product identifier"),
                        product_status: zod
                            .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
                            .default(getProductMergeCandidates200ResponseDataSourceOneProductStatusDefault)
                            .describe("Product publication status"),
                        product_name: zod
                            .string()
                            .max(getProductMergeCandidates200ResponseDataSourceOneProductNameMax)
                            .optional()
                            .describe("Product name (English only)"),
                        product_note: zod
                            .string()
                            .optional()
                            .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                        created_by: zod.number().nullish().describe("User ID who created this product (audit)"),
                        updated_by: zod.number().nullish().describe("User ID who last updated this product (audit)"),
                        product_url: zod
                            .string()
                            .max(getProductMergeCandidates200ResponseDataSourceOneProductUrlMax)
                            .optional()
                            .describe("Product URL"),
                        general_description: zod.string().optional().describe("Product description"),
                        price: zod.number().nullish().describe("Product price"),
                        price_unit: zod
                            .string()
                            .max(getProductMergeCandidates200ResponseDataSourceOnePriceUnitMax)
                            .optional()
                            .describe("Price unit (e.g., THB, USD)"),
                        image: zod.string().optional().describe("Product image URL"),
                        category_id: zod.number().nullish().describe("Category ID (foreign key)"),
                        parent_category_id: zod
                            .number()
                            .nullish()
                            .describe("Parent category ID (derived from category_id)"),
                        parent_category_name: zod
                            .string()
                            .max(getProductMergeCandidates200ResponseDataSourceOneParentCategoryNameMax)
                            .optional()
                            .describe("Parent category name (flattened for client convenience)"),
                        brand_id: zod.number().nullish().describe("Brand ID (foreign key)"),
                        brand_name: zod
                            .string()
                            .max(getProductMergeCandidates200ResponseDataSourceOneBrandNameMax)
                            .optional()
                            .describe("Brand name (flattened for client convenience)"),
                        category_name: zod
                            .string()
                            .max(getProductMergeCandidates200ResponseDataSourceOneCategoryNameMax)
                            .optional()
                            .describe("Category name (flattened for client convenience)"),
                        group_id: zod
                            .union([
                                zod.number().describe("Product group identifier"),
                                zod.string().describe("Product group identifier"),
                            ])
                            .nullish(),
                        likes_count: zod.number().nullish().describe("Number of likes"),
                        comments_count: zod.number().nullish().describe("Number of comments"),
                        reads_count: zod.number().nullish().describe("Number of reads"),
                        unit: zod
                            .string()
                            .max(getProductMergeCandidates200ResponseDataSourceOneUnitMax)
                            .optional()
                            .describe("Product unit (e.g., piece, bottle, box)"),
                        keyword: zod
                            .string()
                            .max(getProductMergeCandidates200ResponseDataSourceOneKeywordMax)
                            .optional()
                            .describe("Search keyword(s)"),
                        how_to_use: zod.string().optional().describe("Usage instructions"),
                        ingredients: zod.string().optional().describe("Ingredients \/ raw materials"),
                        positive_points_th: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (Thai)"),
                        negative_points_th: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (Thai)"),
                        positive_points_en: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (English)"),
                        negative_points_en: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (English)"),
                        positive_points_ja: zod
                            .array(zod.string())
                            .optional()
                            .describe("Positive review points (Japanese)"),
                        negative_points_ja: zod
                            .array(zod.string())
                            .optional()
                            .describe("Negative review points (Japanese)"),
                        review_summary_th: zod.string().optional().describe("Thai review summary"),
                        review_summary_en: zod
                            .string()
                            .max(getProductMergeCandidates200ResponseDataSourceTwoReviewSummaryEnMax)
                            .optional()
                            .describe("English review summary"),
                        review_summary_ja: zod
                            .string()
                            .max(getProductMergeCandidates200ResponseDataSourceTwoReviewSummaryJaMax)
                            .optional()
                            .describe("Japanese review summary"),
                        created_at: zod.string().datetime({ offset: true }).optional().describe("Creation timestamp"),
                        updated_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Last update timestamp"),
                        image_url: zod.string().optional().describe("Canonical absolute image URL"),
                        likes: zod.array(zod.object({}).passthrough()).optional(),
                        comments: zod.array(zod.object({}).passthrough()).optional(),
                        recommend_rank: zod
                            .number()
                            .min(1)
                            .max(getProductMergeCandidates200ResponseDataSourceTwoRecommendRankMax)
                            .nullish()
                            .describe("Recommend rank for crown display (ISS:04-047)"),
                        monthly_rank: zod
                            .number()
                            .min(1)
                            .nullish()
                            .describe(
                                "Monthly ranking rank (materialized; previous month based on real date) (ISS:04-048)",
                            ),
                        manual_score_offset: zod
                            .number()
                            .min(getProductMergeCandidates200ResponseDataSourceTwoManualScoreOffsetMin)
                            .max(getProductMergeCandidates200ResponseDataSourceTwoManualScoreOffsetMax)
                            .nullish()
                            .describe(
                                "Manual score offset added to monthly metric value to stabilize ranking (ISS:05-014)",
                            ),
                        review_count: zod.number().nullish().describe("Total number of reviews for this product"),
                        review_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing review_count — 0 when a guest can't browse to this product (draft\/rejected\/dummy\/duplicated\/brand-placeholder status; equals review_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        posts_count: zod
                            .number()
                            .nullish()
                            .describe(
                                "Total number of posts for this product, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                            ),
                        posts_count_guest: zod
                            .number()
                            .nullish()
                            .describe(
                                "Guest-facing posts_count — 0 when a guest can't browse to this product (same basis as review_count_guest; equals posts_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                            ),
                        average_rating: zod.number().nullish().describe("Average rating from all reviews (1-5 scale)"),
                        likes_by_post: zod
                            .record(zod.string(), zod.array(zod.object({}).passthrough()))
                            .optional()
                            .describe("Likes grouped by post ID for list\/detail convenience"),
                        comments_by_post: zod
                            .record(zod.string(), zod.array(zod.object({}).passthrough()))
                            .optional()
                            .describe("Comments grouped by post ID for list\/detail convenience"),
                        review_question_averages: zod
                            .array(
                                zod
                                    .object({
                                        review_question_id: zod.number().optional().describe("Review question ID"),
                                        average: zod
                                            .number()
                                            .nullish()
                                            .describe("Average score for the review question"),
                                        count: zod
                                            .number()
                                            .optional()
                                            .describe("Number of reviews included in the average"),
                                        data_type: zod
                                            .enum(["rating", "text", "single_select", "multi_select"])
                                            .optional()
                                            .describe("Review question data type"),
                                        question_text_th: zod
                                            .string()
                                            .max(
                                                getProductMergeCandidates200ResponseDataSourceTwoReviewQuestionAveragesItemQuestionTextThMax,
                                            )
                                            .optional()
                                            .describe("Review question text in Thai"),
                                        question_text_en: zod
                                            .string()
                                            .max(
                                                getProductMergeCandidates200ResponseDataSourceTwoReviewQuestionAveragesItemQuestionTextEnMax,
                                            )
                                            .optional()
                                            .describe("Review question text in English"),
                                        question_text_ja: zod
                                            .string()
                                            .max(
                                                getProductMergeCandidates200ResponseDataSourceTwoReviewQuestionAveragesItemQuestionTextJaMax,
                                            )
                                            .optional()
                                            .describe("Review question text in Japanese"),
                                    })
                                    .strict(),
                            )
                            .optional()
                            .describe("Average rating by review question for the product detail view"),
                        category: zod
                            .object({
                                category_id: zod.number().nullish().describe("Category ID"),
                                category_name: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataSourceTwoCategoryCategoryNameMax)
                                    .optional()
                                    .describe("Category name"),
                                category_icon: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataSourceTwoCategoryCategoryIconMax)
                                    .optional()
                                    .describe(
                                        "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                    ),
                                parent_category_id: zod.number().nullish().describe("Parent category ID"),
                                parent_category_name: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataSourceTwoCategoryParentCategoryNameMax)
                                    .optional()
                                    .describe("Parent category name"),
                                display_order: zod.number().optional().describe("Display order"),
                            })
                            .strict()
                            .nullish()
                            .describe("Category information"),
                        brand: zod
                            .object({
                                brand_id: zod.number().nullish().describe("Brand ID"),
                                brand_index: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataSourceTwoBrandBrandIndexMax)
                                    .optional()
                                    .describe("Brand index code"),
                                brand_name: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataSourceTwoBrandBrandNameMax)
                                    .optional()
                                    .describe("Brand name"),
                                image_url: zod.string().optional().describe("Brand logo\/icon URL"),
                                brand_description_th: zod.string().optional().describe("Brand description in Thai"),
                                brand_description_en: zod.string().optional().describe("Brand description in English"),
                                brand_description_ja: zod.string().optional().describe("Brand description in Japanese"),
                                country: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataSourceTwoBrandCountryMax)
                                    .optional()
                                    .describe("Brand country of origin"),
                                website: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataSourceTwoBrandWebsiteMax)
                                    .optional()
                                    .describe("Brand official website"),
                            })
                            .strict()
                            .nullish()
                            .describe("Brand information"),
                        reviews: zod
                            .array(
                                zod
                                    .object({
                                        post_id: zod.number().optional().describe("Post ID"),
                                        board_id: zod
                                            .enum([
                                                "review",
                                                "tiktoks",
                                                "beauty_news",
                                                "editorial_reviews",
                                                "expert_reviews",
                                                "activities",
                                                "test_modal",
                                                "test_modeless",
                                                "guidance",
                                            ])
                                            .optional()
                                            .describe("Board ID (should be 'review')"),
                                        post_product_id: zod
                                            .union([
                                                zod.number().describe("Associated product ID on the post record"),
                                                zod.string().describe("Associated product ID on the post record"),
                                            ])
                                            .nullish(),
                                        user_id: zod.number().optional().describe("User ID who created the review"),
                                        post_title: zod
                                            .string()
                                            .max(
                                                getProductMergeCandidates200ResponseDataSourceTwoReviewsItemPostTitleMax,
                                            )
                                            .optional()
                                            .describe("Review title"),
                                        content: zod.string().optional().describe("Review content"),
                                        attached_images: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Attached image filenames"),
                                        attached_videos: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Attached video filenames"),
                                        content_images: zod
                                            .array(zod.string())
                                            .optional()
                                            .describe("Images extracted from content"),
                                        created_at: zod
                                            .string()
                                            .datetime({ offset: true })
                                            .optional()
                                            .describe("Creation timestamp"),
                                        updated_at: zod
                                            .string()
                                            .datetime({ offset: true })
                                            .optional()
                                            .describe("Last update timestamp"),
                                        user: zod
                                            .object({
                                                user_id: zod.number().optional(),
                                                username: zod.string().optional(),
                                                display_name: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserDisplayNameMax,
                                                    )
                                                    .optional(),
                                                first_name: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserFirstNameMax,
                                                    )
                                                    .optional(),
                                                last_name: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserLastNameMax,
                                                    )
                                                    .optional(),
                                                nick_name: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserNickNameMax,
                                                    )
                                                    .optional(),
                                                date_of_birth: zod.string().date().nullish(),
                                                gender: zod
                                                    .enum(["male", "female", "other", "prefer_not_to_say"])
                                                    .nullish(),
                                                skin_type: zod
                                                    .enum([
                                                        "normal",
                                                        "oily",
                                                        "dry",
                                                        "combination",
                                                        "sensitive",
                                                        "dehydrated_oily",
                                                        "not_sure",
                                                    ])
                                                    .nullish(),
                                                skin_concerns: zod.array(zod.string()).optional(),
                                                skin_tone: zod
                                                    .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                                    .nullish(),
                                                hair_type: zod
                                                    .enum([
                                                        "straight_coarse",
                                                        "straight_soft",
                                                        "wavy_coarse",
                                                        "wavy_soft",
                                                        "normal_hair",
                                                        "not_sure",
                                                    ])
                                                    .nullish(),
                                                hair_scalp_concerns: zod.array(zod.string()).optional(),
                                                beauty_wellness_interests: zod.array(zod.string()).optional(),
                                                lifestyle_environment: zod.array(zod.string()).optional(),
                                                makeup_frequency: zod
                                                    .enum(["every_day", "occasionally", "rarely"])
                                                    .nullish(),
                                                preferred_price_range: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserPreferredPriceRangeMax,
                                                    )
                                                    .optional(),
                                                social_instagram: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialInstagramMax,
                                                    )
                                                    .optional(),
                                                social_facebook: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialFacebookMax,
                                                    )
                                                    .optional(),
                                                social_x: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialXMax,
                                                    )
                                                    .optional(),
                                                social_tiktok: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialTiktokMax,
                                                    )
                                                    .optional(),
                                                social_youtube: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialYoutubeMax,
                                                    )
                                                    .optional(),
                                                social_website: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserSocialWebsiteMax,
                                                    )
                                                    .optional(),
                                                avatar: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataSourceTwoReviewsItemUserAvatarMax,
                                                    )
                                                    .optional(),
                                                role: zod
                                                    .enum(["admin", "editor", "moderator", "expert", "user"])
                                                    .optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                recommend_rank: zod.number().nullish(),
                                                posts_count: zod.number().nullish(),
                                                review_count: zod.number().nullish(),
                                                followers_count: zod.number().optional(),
                                                followings_count: zod.number().optional(),
                                            })
                                            .strict()
                                            .optional()
                                            .describe("User information"),
                                        review_data: zod
                                            .object({
                                                review_answer_id: zod.number().optional(),
                                                review_config_id: zod.union([zod.number(), zod.string()]).optional(),
                                                post_id: zod.number().optional(),
                                                answers: zod.array(zod.object({}).passthrough()).optional(),
                                            })
                                            .strict()
                                            .optional()
                                            .describe("Review answer data from ReviewAnswers"),
                                        delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                        reads_count: zod.number().nullish(),
                                        sns_links: zod.array(zod.string().url()).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        monthly_rank: zod.number().nullish(),
                                        manual_score_offset: zod
                                            .number()
                                            .min(
                                                getProductMergeCandidates200ResponseDataSourceTwoReviewsItemManualScoreOffsetMin,
                                            )
                                            .max(
                                                getProductMergeCandidates200ResponseDataSourceTwoReviewsItemManualScoreOffsetMax,
                                            )
                                            .nullish(),
                                        sns_shares: zod.array(zod.enum(["instagram", "tiktok"])).optional(),
                                        board: zod.record(zod.string(), zod.unknown()).optional(),
                                        likes: zod.array(zod.object({}).passthrough()).optional(),
                                        reads: zod.array(zod.object({}).passthrough()).optional(),
                                        comments: zod.array(zod.object({}).passthrough()).optional(),
                                        review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        reviews_count: zod.number().optional(),
                                        average_rating: zod.number().nullish(),
                                        rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                        has_user_reviewed: zod.boolean().optional(),
                                        review_config: zod.record(zod.string(), zod.unknown()).nullish(),
                                        review_questions: zod.array(zod.record(zod.string(), zod.unknown())).optional(),
                                        likes_count: zod.number().nullish().describe("Number of likes"),
                                        is_liked_by_current_user: zod
                                            .boolean()
                                            .optional()
                                            .describe("Whether current user has liked this product"),
                                        comments_count: zod.number().nullish().describe("Number of comments"),
                                    })
                                    .strict()
                                    .describe("Review post with enriched user, likes, comments, and reads data"),
                            )
                            .optional()
                            .describe("Product reviews with enriched data"),
                    })
                    .strict()
                    .optional(),
                candidates: zod
                    .array(
                        zod
                            .object({
                                product_id: zod.number().optional().describe("Unique product identifier"),
                                product_status: zod
                                    .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
                                    .default(
                                        getProductMergeCandidates200ResponseDataCandidatesItemOneProductStatusDefault,
                                    )
                                    .describe("Product publication status"),
                                product_name: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemOneProductNameMax)
                                    .optional()
                                    .describe("Product name (English only)"),
                                product_note: zod
                                    .string()
                                    .optional()
                                    .describe("Admin\/editor note (also auto-appended to by master:mark-duplicates)."),
                                created_by: zod.number().nullish().describe("User ID who created this product (audit)"),
                                updated_by: zod
                                    .number()
                                    .nullish()
                                    .describe("User ID who last updated this product (audit)"),
                                product_url: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemOneProductUrlMax)
                                    .optional()
                                    .describe("Product URL"),
                                general_description: zod.string().optional().describe("Product description"),
                                price: zod.number().nullish().describe("Product price"),
                                price_unit: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemOnePriceUnitMax)
                                    .optional()
                                    .describe("Price unit (e.g., THB, USD)"),
                                image: zod.string().optional().describe("Product image URL"),
                                category_id: zod.number().nullish().describe("Category ID (foreign key)"),
                                parent_category_id: zod
                                    .number()
                                    .nullish()
                                    .describe("Parent category ID (derived from category_id)"),
                                parent_category_name: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemOneParentCategoryNameMax)
                                    .optional()
                                    .describe("Parent category name (flattened for client convenience)"),
                                brand_id: zod.number().nullish().describe("Brand ID (foreign key)"),
                                brand_name: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemOneBrandNameMax)
                                    .optional()
                                    .describe("Brand name (flattened for client convenience)"),
                                category_name: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemOneCategoryNameMax)
                                    .optional()
                                    .describe("Category name (flattened for client convenience)"),
                                group_id: zod
                                    .union([
                                        zod.number().describe("Product group identifier"),
                                        zod.string().describe("Product group identifier"),
                                    ])
                                    .nullish(),
                                likes_count: zod.number().nullish().describe("Number of likes"),
                                comments_count: zod.number().nullish().describe("Number of comments"),
                                reads_count: zod.number().nullish().describe("Number of reads"),
                                unit: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemOneUnitMax)
                                    .optional()
                                    .describe("Product unit (e.g., piece, bottle, box)"),
                                keyword: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemOneKeywordMax)
                                    .optional()
                                    .describe("Search keyword(s)"),
                                how_to_use: zod.string().optional().describe("Usage instructions"),
                                ingredients: zod.string().optional().describe("Ingredients \/ raw materials"),
                                positive_points_th: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Positive review points (Thai)"),
                                negative_points_th: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Negative review points (Thai)"),
                                positive_points_en: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Positive review points (English)"),
                                negative_points_en: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Negative review points (English)"),
                                positive_points_ja: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Positive review points (Japanese)"),
                                negative_points_ja: zod
                                    .array(zod.string())
                                    .optional()
                                    .describe("Negative review points (Japanese)"),
                                review_summary_th: zod.string().optional().describe("Thai review summary"),
                                review_summary_en: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewSummaryEnMax)
                                    .optional()
                                    .describe("English review summary"),
                                review_summary_ja: zod
                                    .string()
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewSummaryJaMax)
                                    .optional()
                                    .describe("Japanese review summary"),
                                created_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Creation timestamp"),
                                updated_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Last update timestamp"),
                                image_url: zod.string().optional().describe("Canonical absolute image URL"),
                                likes: zod.array(zod.object({}).passthrough()).optional(),
                                comments: zod.array(zod.object({}).passthrough()).optional(),
                                recommend_rank: zod
                                    .number()
                                    .min(1)
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemTwoRecommendRankMax)
                                    .nullish()
                                    .describe("Recommend rank for crown display (ISS:04-047)"),
                                monthly_rank: zod
                                    .number()
                                    .min(1)
                                    .nullish()
                                    .describe(
                                        "Monthly ranking rank (materialized; previous month based on real date) (ISS:04-048)",
                                    ),
                                manual_score_offset: zod
                                    .number()
                                    .min(getProductMergeCandidates200ResponseDataCandidatesItemTwoManualScoreOffsetMin)
                                    .max(getProductMergeCandidates200ResponseDataCandidatesItemTwoManualScoreOffsetMax)
                                    .nullish()
                                    .describe(
                                        "Manual score offset added to monthly metric value to stabilize ranking (ISS:05-014)",
                                    ),
                                review_count: zod
                                    .number()
                                    .nullish()
                                    .describe("Total number of reviews for this product"),
                                review_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Guest-facing review_count — 0 when a guest can't browse to this product (draft\/rejected\/dummy\/duplicated\/brand-placeholder status; equals review_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                                    ),
                                posts_count: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Total number of posts for this product, across all board types (review, articles, tiktoks) — not just reviews. Admin\/editor-facing (unfiltered).",
                                    ),
                                posts_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Guest-facing posts_count — 0 when a guest can't browse to this product (same basis as review_count_guest; equals posts_count otherwise). Pre-computed by the products:update-stats batch (ISS-01-190).",
                                    ),
                                average_rating: zod
                                    .number()
                                    .nullish()
                                    .describe("Average rating from all reviews (1-5 scale)"),
                                likes_by_post: zod
                                    .record(zod.string(), zod.array(zod.object({}).passthrough()))
                                    .optional()
                                    .describe("Likes grouped by post ID for list\/detail convenience"),
                                comments_by_post: zod
                                    .record(zod.string(), zod.array(zod.object({}).passthrough()))
                                    .optional()
                                    .describe("Comments grouped by post ID for list\/detail convenience"),
                                review_question_averages: zod
                                    .array(
                                        zod
                                            .object({
                                                review_question_id: zod
                                                    .number()
                                                    .optional()
                                                    .describe("Review question ID"),
                                                average: zod
                                                    .number()
                                                    .nullish()
                                                    .describe("Average score for the review question"),
                                                count: zod
                                                    .number()
                                                    .optional()
                                                    .describe("Number of reviews included in the average"),
                                                data_type: zod
                                                    .enum(["rating", "text", "single_select", "multi_select"])
                                                    .optional()
                                                    .describe("Review question data type"),
                                                question_text_th: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewQuestionAveragesItemQuestionTextThMax,
                                                    )
                                                    .optional()
                                                    .describe("Review question text in Thai"),
                                                question_text_en: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewQuestionAveragesItemQuestionTextEnMax,
                                                    )
                                                    .optional()
                                                    .describe("Review question text in English"),
                                                question_text_ja: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewQuestionAveragesItemQuestionTextJaMax,
                                                    )
                                                    .optional()
                                                    .describe("Review question text in Japanese"),
                                            })
                                            .strict(),
                                    )
                                    .optional()
                                    .describe("Average rating by review question for the product detail view"),
                                category: zod
                                    .object({
                                        category_id: zod.number().nullish().describe("Category ID"),
                                        category_name: zod
                                            .string()
                                            .max(
                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoCategoryCategoryNameMax,
                                            )
                                            .optional()
                                            .describe("Category name"),
                                        category_icon: zod
                                            .string()
                                            .max(
                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoCategoryCategoryIconMax,
                                            )
                                            .optional()
                                            .describe(
                                                "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                            ),
                                        parent_category_id: zod.number().nullish().describe("Parent category ID"),
                                        parent_category_name: zod
                                            .string()
                                            .max(
                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoCategoryParentCategoryNameMax,
                                            )
                                            .optional()
                                            .describe("Parent category name"),
                                        display_order: zod.number().optional().describe("Display order"),
                                    })
                                    .strict()
                                    .nullish()
                                    .describe("Category information"),
                                brand: zod
                                    .object({
                                        brand_id: zod.number().nullish().describe("Brand ID"),
                                        brand_index: zod
                                            .string()
                                            .max(
                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoBrandBrandIndexMax,
                                            )
                                            .optional()
                                            .describe("Brand index code"),
                                        brand_name: zod
                                            .string()
                                            .max(
                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoBrandBrandNameMax,
                                            )
                                            .optional()
                                            .describe("Brand name"),
                                        image_url: zod.string().optional().describe("Brand logo\/icon URL"),
                                        brand_description_th: zod
                                            .string()
                                            .optional()
                                            .describe("Brand description in Thai"),
                                        brand_description_en: zod
                                            .string()
                                            .optional()
                                            .describe("Brand description in English"),
                                        brand_description_ja: zod
                                            .string()
                                            .optional()
                                            .describe("Brand description in Japanese"),
                                        country: zod
                                            .string()
                                            .max(
                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoBrandCountryMax,
                                            )
                                            .optional()
                                            .describe("Brand country of origin"),
                                        website: zod
                                            .string()
                                            .max(
                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoBrandWebsiteMax,
                                            )
                                            .optional()
                                            .describe("Brand official website"),
                                    })
                                    .strict()
                                    .nullish()
                                    .describe("Brand information"),
                                reviews: zod
                                    .array(
                                        zod
                                            .object({
                                                post_id: zod.number().optional().describe("Post ID"),
                                                board_id: zod
                                                    .enum([
                                                        "review",
                                                        "tiktoks",
                                                        "beauty_news",
                                                        "editorial_reviews",
                                                        "expert_reviews",
                                                        "activities",
                                                        "test_modal",
                                                        "test_modeless",
                                                        "guidance",
                                                    ])
                                                    .optional()
                                                    .describe("Board ID (should be 'review')"),
                                                post_product_id: zod
                                                    .union([
                                                        zod
                                                            .number()
                                                            .describe("Associated product ID on the post record"),
                                                        zod
                                                            .string()
                                                            .describe("Associated product ID on the post record"),
                                                    ])
                                                    .nullish(),
                                                user_id: zod
                                                    .number()
                                                    .optional()
                                                    .describe("User ID who created the review"),
                                                post_title: zod
                                                    .string()
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemPostTitleMax,
                                                    )
                                                    .optional()
                                                    .describe("Review title"),
                                                content: zod.string().optional().describe("Review content"),
                                                attached_images: zod
                                                    .array(zod.string())
                                                    .optional()
                                                    .describe("Attached image filenames"),
                                                attached_videos: zod
                                                    .array(zod.string())
                                                    .optional()
                                                    .describe("Attached video filenames"),
                                                content_images: zod
                                                    .array(zod.string())
                                                    .optional()
                                                    .describe("Images extracted from content"),
                                                created_at: zod
                                                    .string()
                                                    .datetime({ offset: true })
                                                    .optional()
                                                    .describe("Creation timestamp"),
                                                updated_at: zod
                                                    .string()
                                                    .datetime({ offset: true })
                                                    .optional()
                                                    .describe("Last update timestamp"),
                                                user: zod
                                                    .object({
                                                        user_id: zod.number().optional(),
                                                        username: zod.string().optional(),
                                                        display_name: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserDisplayNameMax,
                                                            )
                                                            .optional(),
                                                        first_name: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserFirstNameMax,
                                                            )
                                                            .optional(),
                                                        last_name: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserLastNameMax,
                                                            )
                                                            .optional(),
                                                        nick_name: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserNickNameMax,
                                                            )
                                                            .optional(),
                                                        date_of_birth: zod.string().date().nullish(),
                                                        gender: zod
                                                            .enum(["male", "female", "other", "prefer_not_to_say"])
                                                            .nullish(),
                                                        skin_type: zod
                                                            .enum([
                                                                "normal",
                                                                "oily",
                                                                "dry",
                                                                "combination",
                                                                "sensitive",
                                                                "dehydrated_oily",
                                                                "not_sure",
                                                            ])
                                                            .nullish(),
                                                        skin_concerns: zod.array(zod.string()).optional(),
                                                        skin_tone: zod
                                                            .enum([
                                                                "very_fair",
                                                                "fair",
                                                                "medium",
                                                                "tan",
                                                                "deep",
                                                                "not_sure",
                                                            ])
                                                            .nullish(),
                                                        hair_type: zod
                                                            .enum([
                                                                "straight_coarse",
                                                                "straight_soft",
                                                                "wavy_coarse",
                                                                "wavy_soft",
                                                                "normal_hair",
                                                                "not_sure",
                                                            ])
                                                            .nullish(),
                                                        hair_scalp_concerns: zod.array(zod.string()).optional(),
                                                        beauty_wellness_interests: zod.array(zod.string()).optional(),
                                                        lifestyle_environment: zod.array(zod.string()).optional(),
                                                        makeup_frequency: zod
                                                            .enum(["every_day", "occasionally", "rarely"])
                                                            .nullish(),
                                                        preferred_price_range: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserPreferredPriceRangeMax,
                                                            )
                                                            .optional(),
                                                        social_instagram: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialInstagramMax,
                                                            )
                                                            .optional(),
                                                        social_facebook: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialFacebookMax,
                                                            )
                                                            .optional(),
                                                        social_x: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialXMax,
                                                            )
                                                            .optional(),
                                                        social_tiktok: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialTiktokMax,
                                                            )
                                                            .optional(),
                                                        social_youtube: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialYoutubeMax,
                                                            )
                                                            .optional(),
                                                        social_website: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserSocialWebsiteMax,
                                                            )
                                                            .optional(),
                                                        avatar: zod
                                                            .string()
                                                            .max(
                                                                getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemUserAvatarMax,
                                                            )
                                                            .optional(),
                                                        role: zod
                                                            .enum(["admin", "editor", "moderator", "expert", "user"])
                                                            .optional(),
                                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                                        recommend_rank: zod.number().nullish(),
                                                        posts_count: zod.number().nullish(),
                                                        review_count: zod.number().nullish(),
                                                        followers_count: zod.number().optional(),
                                                        followings_count: zod.number().optional(),
                                                    })
                                                    .strict()
                                                    .optional()
                                                    .describe("User information"),
                                                review_data: zod
                                                    .object({
                                                        review_answer_id: zod.number().optional(),
                                                        review_config_id: zod
                                                            .union([zod.number(), zod.string()])
                                                            .optional(),
                                                        post_id: zod.number().optional(),
                                                        answers: zod.array(zod.object({}).passthrough()).optional(),
                                                    })
                                                    .strict()
                                                    .optional()
                                                    .describe("Review answer data from ReviewAnswers"),
                                                delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                                post_status: zod
                                                    .enum(["draft", "editing", "released", "rejected"])
                                                    .optional(),
                                                reads_count: zod.number().nullish(),
                                                sns_links: zod.array(zod.string().url()).optional(),
                                                recommend_rank: zod.number().nullish(),
                                                monthly_rank: zod.number().nullish(),
                                                manual_score_offset: zod
                                                    .number()
                                                    .min(
                                                        getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemManualScoreOffsetMin,
                                                    )
                                                    .max(
                                                        getProductMergeCandidates200ResponseDataCandidatesItemTwoReviewsItemManualScoreOffsetMax,
                                                    )
                                                    .nullish(),
                                                sns_shares: zod.array(zod.enum(["instagram", "tiktok"])).optional(),
                                                board: zod.record(zod.string(), zod.unknown()).optional(),
                                                likes: zod.array(zod.object({}).passthrough()).optional(),
                                                reads: zod.array(zod.object({}).passthrough()).optional(),
                                                comments: zod.array(zod.object({}).passthrough()).optional(),
                                                review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                                reviews_count: zod.number().optional(),
                                                average_rating: zod.number().nullish(),
                                                rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                                has_user_reviewed: zod.boolean().optional(),
                                                review_config: zod.record(zod.string(), zod.unknown()).nullish(),
                                                review_questions: zod
                                                    .array(zod.record(zod.string(), zod.unknown()))
                                                    .optional(),
                                                likes_count: zod.number().nullish().describe("Number of likes"),
                                                is_liked_by_current_user: zod
                                                    .boolean()
                                                    .optional()
                                                    .describe("Whether current user has liked this product"),
                                                comments_count: zod.number().nullish().describe("Number of comments"),
                                            })
                                            .strict()
                                            .describe(
                                                "Review post with enriched user, likes, comments, and reads data",
                                            ),
                                    )
                                    .optional()
                                    .describe("Product reviews with enriched data"),
                            })
                            .strict(),
                    )
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetProductMergeCandidates401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const GetProductMergeCandidates403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const GetProductMergeCandidates500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * Reassigns every child reference (posts, product_likes, product_recommends, review_answers, review_summaries, ads, affiliate_clicks, rankings, search_suggests, users.favorite_products) from product_id (path) to target_id, applies the chosen field values onto the target, and appends a merge record to both sides' product_note. The source product itself is not deleted.
 * @summary Merge a duplicated product into a target product (admin/editor only)
 */
export const MergeProductParams = zod
    .object({
        product_id: zod.number().describe("Source product ID (the duplicated one being merged away)"),
    })
    .strict();

export const MergeProductBody = zod
    .object({
        target_id: zod.number(),
        fields: zod
            .record(zod.string(), zod.enum(["source", "target"]))
            .optional()
            .describe(
                'Only fields set to \"source\" are copied onto the target; anything else (including fields not present) keeps the target\'s existing value.',
            ),
    })
    .strict();

export const MergeProduct200Response = zod
    .object({
        data: zod
            .object({
                reassigned: zod.record(zod.string(), zod.number()).optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const MergeProduct401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const MergeProduct403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const MergeProduct404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const MergeProduct422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const MergeProduct500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * @summary Upload product image (admin/editor only)
 */
export const UploadImageParams = zod
    .object({
        product_id: zod.number().describe("Product ID"),
    })
    .strict();

export const UploadImageBody = zod
    .object({
        product_image: zod.instanceof(File),
    })
    .strict();

export const UploadImage200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                image_url: zod.string().optional(),
                filename: zod.string().nullish(),
                message: zod.string().nullish(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UploadImage401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UploadImage403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UploadImage404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UploadImage422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UploadImage500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * @summary Probe an image URL's real HTTP status server-side (admin/editor only). Used by the product card broken-image diagnostic badge — browsers can't read the status of a failed cross-origin image request themselves when the host doesn't send CORS headers, so the check has to happen on the server instead.
 */
export const GetImageStatusQueryParams = zod
    .object({
        url: zod
            .string()
            .describe("Image URL to probe (must resolve to a public host — private\/internal IPs are rejected)"),
    })
    .strict();

export const GetImageStatus200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                status: zod
                    .string()
                    .optional()
                    .describe(
                        'The probed HTTP status code as a string (e.g. \"403\", \"404\"), or a sentinel (\"ERR\", \"TIMEOUT\", \"INVALID\") when no real HTTP response was obtained.',
                    ),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetImageStatus401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const GetImageStatus403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const GetImageStatus422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * @summary Add a like to a product
 */
export const AddLikeParams = zod
    .object({
        product_id: zod.number().describe("Product ID"),
    })
    .strict();

export const AddLike201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                likes_count: zod.number().nullish(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const AddLike400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const AddLike401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const AddLike404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const AddLike500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * @summary Remove a like from a product
 */
export const RemoveLikeParams = zod
    .object({
        product_id: zod.number().describe("Product ID"),
    })
    .strict();

export const RemoveLike200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                likes_count: zod.number().nullish(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const RemoveLike400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const RemoveLike401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const RemoveLike404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const RemoveLike500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * Used by the rank selection popup to disable already-used ranks (admin/editor only).
 * @summary Get recommend meta (used ranks, current rank)
 */
export const GetProductRecommendMetaParams = zod
    .object({
        product_id: zod.number().describe("Product ID"),
    })
    .strict();

export const getProductRecommendMeta200ResponseDataCurrentRankMax = 15;

export const GetProductRecommendMeta200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                product_id: zod.number(),
                max_rank: zod.number(),
                current_rank: zod.number().min(1).max(getProductRecommendMeta200ResponseDataCurrentRankMax).nullable(),
                used_ranks: zod.array(zod.number()),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetProductRecommendMeta401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const GetProductRecommendMeta403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const GetProductRecommendMeta404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const GetProductRecommendMeta500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * Set or update recommend rank. Rank can be null (admin/editor only).
 * @summary Set/update recommend rank
 */
export const UpsertProductRecommendParams = zod
    .object({
        product_id: zod.number().describe("Product ID"),
    })
    .strict();

export const upsertProductRecommendBodyRankMax = 15;

export const UpsertProductRecommendBody = zod
    .object({
        rank: zod.number().min(1).max(upsertProductRecommendBodyRankMax).optional(),
    })
    .strict();

export const upsertProductRecommend200ResponseDataRankMax = 15;

export const UpsertProductRecommend200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                product_id: zod.number(),
                rank: zod.number().min(1).max(upsertProductRecommend200ResponseDataRankMax),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UpsertProductRecommend400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpsertProductRecommend401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpsertProductRecommend403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpsertProductRecommend404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpsertProductRecommend409Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpsertProductRecommend422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const UpsertProductRecommend500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

/**
 * Remove recommend entry for the product (admin/editor only).
 * @summary Unset recommend
 */
export const RemoveProductRecommendParams = zod
    .object({
        product_id: zod.number().describe("Product ID"),
    })
    .strict();

export const RemoveProductRecommend200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                product_id: zod.number(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const RemoveProductRecommend400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const RemoveProductRecommend401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const RemoveProductRecommend403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const RemoveProductRecommend404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();

export const RemoveProductRecommend500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional(),
    })
    .strict();
